// AUTO-GENERATED by tools/gen-asset-hashes.mjs — do not edit.
/** static/ relative path → content hash (URL `?v=`). */
export const ASSET_HASHES: Readonly<Record<string, string>> = {
  "audio/abyss_cast.wav.m4a": "WE1X8ZZM",
  "audio/abyss_cast.wav.ogg": "onUjhiTi",
  "audio/abyss_curse.wav.m4a": "V1dzdMaP",
  "audio/abyss_curse.wav.ogg": "xtptiNKk",
  "audio/abyss_drain.wav.m4a": "0W8UxoNh",
  "audio/abyss_drain.wav.ogg": "YEtyTlUJ",
  "audio/abyss_drain_cast.wav.m4a": "rlKXn5nn",
  "audio/abyss_drain_cast.wav.ogg": "AniS57gM",
  "audio/abyss_harvest.wav.m4a": "RrktaDTN",
  "audio/abyss_harvest.wav.ogg": "Of5JMN8H",
  "audio/abyss_hex.wav.m4a": "RTRTrf66",
  "audio/abyss_hex.wav.ogg": "pJnuqP28",
  "audio/abyss_hush.wav.m4a": "QgOlcwoD",
  "audio/abyss_hush.wav.ogg": "NGRRDM3I",
  "audio/abyss_orb.wav.m4a": "K5LI_tSL",
  "audio/abyss_orb.wav.ogg": "gohG8jBV",
  "audio/abyss_orb_charge.wav.m4a": "E3hoHXJq",
  "audio/abyss_orb_charge.wav.ogg": "LzIlcUP8",
  "audio/abyss_orb_hit.wav.m4a": "oUz3gQbP",
  "audio/abyss_orb_hit.wav.ogg": "iwaDcxQX",
  "audio/abyss_pact.wav.m4a": "s_RQPUxM",
  "audio/abyss_pact.wav.ogg": "-sm_Jg3N",
  "audio/ash_aggro.wav.m4a": "M4JIcLuj",
  "audio/ash_aggro.wav.ogg": "yHg8sAx7",
  "audio/ash_hit.wav.m4a": "rJq7pKCo",
  "audio/ash_hit.wav.ogg": "onw6ZLzT",
  "audio/ash_swing.wav.m4a": "kw6GUutN",
  "audio/ash_swing.wav.ogg": "vODu7onq",
  "audio/bear_hit.wav.m4a": "C32rgzOW",
  "audio/bear_hit.wav.ogg": "uEiX8e6z",
  "audio/bear_rage.wav.m4a": "Ri8PEceZ",
  "audio/bear_rage.wav.ogg": "5MgnD5_h",
  "audio/bear_roar.wav.m4a": "zNUUwiiR",
  "audio/bear_roar.wav.ogg": "SW3JPbcr",
  "audio/bear_swing.wav.m4a": "c6SAVCHA",
  "audio/bear_swing.wav.ogg": "hRhou839",
  "audio/beast_hit.wav.m4a": "gzSoVNeO",
  "audio/beast_hit.wav.ogg": "7GNsrKbN",
  "audio/beast_swing.wav.m4a": "qFSMKb9L",
  "audio/beast_swing.wav.ogg": "100kMp6p",
  "audio/berserk_arc.wav.m4a": "C8pzBg3z",
  "audio/berserk_arc.wav.ogg": "KSudjhKM",
  "audio/berserk_chop.wav.m4a": "iYQ7HR6p",
  "audio/berserk_chop.wav.ogg": "_lxTRwKL",
  "audio/berserk_hit.wav.m4a": "8nVYrL0G",
  "audio/berserk_hit.wav.ogg": "3liyhcMv",
  "audio/berserk_mist.wav.m4a": "QugW9OwM",
  "audio/berserk_mist.wav.ogg": "ojdNrbu1",
  "audio/berserk_step.wav.m4a": "o5mBOP2I",
  "audio/berserk_step.wav.ogg": "3hzHfAMq",
  "audio/berserk_throat.wav.m4a": "iT5rZhRD",
  "audio/berserk_throat.wav.ogg": "0jOZyyco",
  "audio/bow.wav.m4a": "0B5RnOBt",
  "audio/bow.wav.ogg": "b6Ty3MI1",
  "audio/brute_hit.wav.m4a": "R6znof6r",
  "audio/brute_hit.wav.ogg": "dsoRgitw",
  "audio/brute_swing.wav.m4a": "4QQ6evbz",
  "audio/brute_swing.wav.ogg": "28_85wYK",
  "audio/charge.wav.m4a": "xtL3IF-C",
  "audio/charge.wav.ogg": "sUmc5R7p",
  "audio/crit_hit.wav.m4a": "6Vqxvi2E",
  "audio/crit_hit.wav.ogg": "jQERY_g9",
  "audio/dance_fan.wav.m4a": "7cF2h5kr",
  "audio/dance_fan.wav.ogg": "Jypi218k",
  "audio/dance_glide.wav.m4a": "KL0rtafz",
  "audio/dance_glide.wav.ogg": "nLncm99y",
  "audio/dark_blight.wav.m4a": "2mqYTZjg",
  "audio/dark_blight.wav.ogg": "d_89qvqo",
  "audio/dark_blight_hit.wav.m4a": "P9YmPgiJ",
  "audio/dark_blight_hit.wav.ogg": "l6cEmvw4",
  "audio/dark_dose.wav.m4a": "MYAkEuoR",
  "audio/dark_dose.wav.ogg": "KWafWBtB",
  "audio/dark_dose_hit.wav.m4a": "ModaAFzF",
  "audio/dark_dose_hit.wav.ogg": "W64sIJyV",
  "audio/dark_draw.wav.m4a": "Av2sEAJ_",
  "audio/dark_draw.wav.ogg": "f5P1n0Zj",
  "audio/dark_drip.wav.m4a": "KKZXdAxu",
  "audio/dark_drip.wav.ogg": "3lukeOOS",
  "audio/dark_numb.wav.m4a": "bjvMhsS3",
  "audio/dark_numb.wav.ogg": "-mbl2kFJ",
  "audio/dark_numb_hit.wav.m4a": "LXwxaUKS",
  "audio/dark_numb_hit.wav.ogg": "tSVlkqFa",
  "audio/dark_rot.wav.m4a": "04zPlaps",
  "audio/dark_rot.wav.ogg": "w_ks72OR",
  "audio/dark_rot_hit.wav.m4a": "hiscgRQN",
  "audio/dark_rot_hit.wav.ogg": "GvCmiyhT",
  "audio/dark_step.wav.m4a": "ABlWwGxM",
  "audio/dark_step.wav.ogg": "JKjGzlR9",
  "audio/dark_venom.wav.m4a": "2sKiYOJ9",
  "audio/dark_venom.wav.ogg": "A7MXPk-F",
  "audio/dark_venom_hit.wav.m4a": "P8s7D8_5",
  "audio/dark_venom_hit.wav.ogg": "BtSbyfwN",
  "audio/dash.wav.m4a": "owgHi0cw",
  "audio/dash.wav.ogg": "j63vXn3L",
  "audio/death_execute.wav.m4a": "8ppJlEmW",
  "audio/death_execute.wav.ogg": "s0NOzqRF",
  "audio/duel_parry.wav.m4a": "iJwpSl-X",
  "audio/duel_parry.wav.ogg": "wEnMCyDG",
  "audio/dusk_fan.wav.m4a": "MY0byycD",
  "audio/dusk_fan.wav.ogg": "F8rxV6Wu",
  "audio/dusk_glide.wav.m4a": "I46ozvoE",
  "audio/dusk_glide.wav.ogg": "4L1nJkZH",
  "audio/dusk_precise.wav.m4a": "zBa7Gj1B",
  "audio/dusk_precise.wav.ogg": "IEZ5t2Ea",
  "audio/earthquake.wav.m4a": "2uD4rGgy",
  "audio/earthquake.wav.ogg": "ux_59H_L",
  "audio/elf_barbs.wav.m4a": "kyto3ZsO",
  "audio/elf_barbs.wav.ogg": "qyqBRUWN",
  "audio/elf_cover.wav.m4a": "6DmyeZ5g",
  "audio/elf_cover.wav.ogg": "fwzZdb1R",
  "audio/elf_draw.wav.m4a": "OOIGm6pa",
  "audio/elf_draw.wav.ogg": "GOUHPGyn",
  "audio/elf_echo.wav.m4a": "lfHjtgYK",
  "audio/elf_echo.wav.ogg": "_PxpjI5s",
  "audio/elf_hit.wav.m4a": "3Snkn0in",
  "audio/elf_hit.wav.ogg": "gFetcqYC",
  "audio/elf_hush.wav.m4a": "97LwWLBN",
  "audio/elf_hush.wav.ogg": "F6sZW2Ac",
  "audio/elf_hush_hit.wav.m4a": "U_p5a4X8",
  "audio/elf_hush_hit.wav.ogg": "18URIXoy",
  "audio/elf_leap.wav.m4a": "_gZuzR--",
  "audio/elf_leap.wav.ogg": "cRDImNB7",
  "audio/elf_mark.wav.m4a": "QkUe6owS",
  "audio/elf_mark.wav.ogg": "3kCefP3q",
  "audio/elf_mark_hit.wav.m4a": "9F4n114o",
  "audio/elf_mark_hit.wav.ogg": "SKHnyxvj",
  "audio/elf_tremor.wav.m4a": "CmIn26F7",
  "audio/elf_tremor.wav.ogg": "ljHZiAW_",
  "audio/fire_cloak.wav.m4a": "K34g2Zni",
  "audio/fire_cloak.wav.ogg": "6bhNawQ7",
  "audio/fire_storm.wav.m4a": "qhpewV_x",
  "audio/fire_storm.wav.ogg": "juAVrTdL",
  "audio/fireball_cast.wav.m4a": "tXqdvA8T",
  "audio/fireball_cast.wav.ogg": "Fzt8kw8c",
  "audio/fireball_charge.wav.m4a": "VJecj7tg",
  "audio/fireball_charge.wav.ogg": "UYLdPNoi",
  "audio/fireball_hit.wav.m4a": "TvsYQj9J",
  "audio/fireball_hit.wav.ogg": "7jFpnnVF",
  "audio/flame_dash.wav.m4a": "LKwVGGSX",
  "audio/flame_dash.wav.ogg": "u6lfRIKl",
  "audio/flame_fist_hit.wav.m4a": "MqyLrbUe",
  "audio/flame_fist_hit.wav.ogg": "zYWSMBwG",
  "audio/flame_fist_swing.wav.m4a": "ygMf8eb8",
  "audio/flame_fist_swing.wav.ogg": "h9hMkEBK",
  "audio/flame_pillar.wav.m4a": "SDUGw6EH",
  "audio/flame_pillar.wav.ogg": "E8mza6Mz",
  "audio/flame_rage.wav.m4a": "nDtVle47",
  "audio/flame_rage.wav.ogg": "g7yxClol",
  "audio/flame_series_hit.wav.m4a": "hQXnjvbz",
  "audio/flame_series_hit.wav.ogg": "MOrv44yg",
  "audio/flame_strike_hit.wav.m4a": "mHeu1VEW",
  "audio/flame_strike_hit.wav.ogg": "N-co1p9O",
  "audio/flame_swing.wav.m4a": "OhUj0fjX",
  "audio/flame_swing.wav.ogg": "JqtlgWcT",
  "audio/forge_aggro.wav.m4a": "Wm3bvtqE",
  "audio/forge_aggro.wav.ogg": "StMqd6KO",
  "audio/forge_block.wav.m4a": "GG_zCici",
  "audio/forge_block.wav.ogg": "n1vFCabJ",
  "audio/forge_call.wav.m4a": "D5iSkJyi",
  "audio/forge_call.wav.ogg": "FZFfMnIV",
  "audio/forge_clang.wav.m4a": "NBGRHABZ",
  "audio/forge_clang.wav.ogg": "hup4ACPP",
  "audio/forge_death.wav.m4a": "eqbZEKbE",
  "audio/forge_death.wav.ogg": "iCLkieeY",
  "audio/forge_edge.wav.m4a": "vZfXBmrC",
  "audio/forge_edge.wav.ogg": "lLSluVPU",
  "audio/forge_flat.wav.m4a": "Urw8A9xc",
  "audio/forge_flat.wav.ogg": "vfuNsKOK",
  "audio/forge_hit.wav.m4a": "tIE4awRJ",
  "audio/forge_hit.wav.ogg": "JxRMURP7",
  "audio/forge_might.wav.m4a": "DI7FPUYi",
  "audio/forge_might.wav.ogg": "5tYhc-EB",
  "audio/forge_stance.wav.m4a": "JcuyO8cs",
  "audio/forge_stance.wav.ogg": "_3ClOQZg",
  "audio/forge_swing.wav.m4a": "hYMQk7fy",
  "audio/forge_swing.wav.ogg": "eVjxAamL",
  "audio/ghost_death.wav.m4a": "80HQ8ofZ",
  "audio/ghost_death.wav.ogg": "a7OcFxhn",
  "audio/ghost_hit.wav.m4a": "PqUkziFK",
  "audio/ghost_hit.wav.ogg": "5sBCrIa7",
  "audio/ghost_wail.wav.m4a": "dVIbYyEN",
  "audio/ghost_wail.wav.ogg": "1Pz3vDtV",
  "audio/glad_brace.wav.m4a": "txwVE9db",
  "audio/glad_brace.wav.ogg": "e_FtNjuP",
  "audio/glad_cleave.wav.m4a": "0BmYEO95",
  "audio/glad_cleave.wav.ogg": "Wfp6q9eh",
  "audio/glad_cut.wav.m4a": "znaYh5iv",
  "audio/glad_cut.wav.ogg": "kq3PXjNK",
  "audio/glad_finish.wav.m4a": "XOfs8dIo",
  "audio/glad_finish.wav.ogg": "ZmaNK6KJ",
  "audio/glad_finish_hit.wav.m4a": "8jb4lqV3",
  "audio/glad_finish_hit.wav.ogg": "dCT1BgQv",
  "audio/glad_grit.wav.m4a": "Srpgm-qj",
  "audio/glad_grit.wav.ogg": "1cjbt2o8",
  "audio/glad_rush.wav.m4a": "RUvw0InL",
  "audio/glad_rush.wav.ogg": "KtWf2xSL",
  "audio/glad_rush_hit.wav.m4a": "r3BPLfaA",
  "audio/glad_rush_hit.wav.ogg": "PJBJyt_k",
  "audio/glad_strike.wav.m4a": "cIX31Upk",
  "audio/glad_strike.wav.ogg": "tuXzK_hP",
  "audio/grove_bloom.wav.m4a": "6K2z4OvC",
  "audio/grove_bloom.wav.ogg": "w_b61FHW",
  "audio/grove_heartwood.wav.m4a": "GV6yE7vR",
  "audio/grove_heartwood.wav.ogg": "RZEFc3h6",
  "audio/grove_heartwood_hit.wav.m4a": "BW5SCgx2",
  "audio/grove_heartwood_hit.wav.ogg": "XmVzxmAg",
  "audio/grove_pollen.wav.m4a": "3PHlZ4QF",
  "audio/grove_pollen.wav.ogg": "3fK5M6lV",
  "audio/grove_pollen_hit.wav.m4a": "r8-jh1Yz",
  "audio/grove_pollen_hit.wav.ogg": "bxtQIP3a",
  "audio/grove_ray_cast.wav.m4a": "KYPb_EHM",
  "audio/grove_ray_cast.wav.ogg": "INGEFELX",
  "audio/grove_ray_hit.wav.m4a": "_7kRYrtN",
  "audio/grove_ray_hit.wav.ogg": "RgYIHxXV",
  "audio/grove_rescue.wav.m4a": "aMpcLc4F",
  "audio/grove_rescue.wav.ogg": "ghu1y-ZF",
  "audio/grove_sap.wav.m4a": "19LPh0fT",
  "audio/grove_sap.wav.ogg": "tuO8Ir6z",
  "audio/grove_sap_hit.wav.m4a": "GNOQYR8e",
  "audio/grove_sap_hit.wav.ogg": "z2RpTFRU",
  "audio/grove_seed_cast.wav.m4a": "S20KwACg",
  "audio/grove_seed_cast.wav.ogg": "4jFSvHCI",
  "audio/grove_seed_hit.wav.m4a": "1CNtje52",
  "audio/grove_seed_hit.wav.ogg": "v0eapR3j",
  "audio/grove_spring.wav.m4a": "STR2aNMP",
  "audio/grove_spring.wav.ogg": "wqShEC9K",
  "audio/grove_spring_hit.wav.m4a": "kD2wrAjy",
  "audio/grove_spring_hit.wav.ogg": "PlfGYz45",
  "audio/hammer_aa.wav.m4a": "AHUJP85o",
  "audio/hammer_aa.wav.ogg": "qIODAmvM",
  "audio/hammer_arc.wav.m4a": "yNfaQEey",
  "audio/hammer_arc.wav.ogg": "uOGfFEG_",
  "audio/hammer_fell.wav.m4a": "11sgKyEx",
  "audio/hammer_fell.wav.ogg": "Db2THQII",
  "audio/hammer_helm.wav.m4a": "57zGAPHa",
  "audio/hammer_helm.wav.ogg": "DHbiXk7_",
  "audio/hammer_hit.wav.m4a": "j-f70Zf-",
  "audio/hammer_hit.wav.ogg": "Szb9slsl",
  "audio/hammer_peak.wav.m4a": "Nxl_oCql",
  "audio/hammer_peak.wav.ogg": "_zl3WU3U",
  "audio/hammer_pin.wav.m4a": "CmKieowB",
  "audio/hammer_pin.wav.ogg": "1AvPhas1",
  "audio/hammer_wind.wav.m4a": "08abgjSx",
  "audio/hammer_wind.wav.ogg": "gSYjUamR",
  "audio/hearth_edge_cast.wav.m4a": "m4WTc6q4",
  "audio/hearth_edge_cast.wav.ogg": "wGLgPqO2",
  "audio/hearth_edge_hit.wav.m4a": "Gra0YSnt",
  "audio/hearth_edge_hit.wav.ogg": "WlTecmeQ",
  "audio/hearth_keen_cast.wav.m4a": "_kF5OWxS",
  "audio/hearth_keen_cast.wav.ogg": "AmqKttWm",
  "audio/hearth_keen_hit.wav.m4a": "ML28NZT9",
  "audio/hearth_keen_hit.wav.ogg": "bTHiX5Jm",
  "audio/hearth_mail_cast.wav.m4a": "3_MK3px3",
  "audio/hearth_mail_cast.wav.ogg": "7rWSA0VB",
  "audio/hearth_mail_hit.wav.m4a": "IPiOKoIx",
  "audio/hearth_mail_hit.wav.ogg": "5vIiWbW3",
  "audio/hearth_quench_cast.wav.m4a": "hsEh9Y3o",
  "audio/hearth_quench_cast.wav.ogg": "bovd4m1L",
  "audio/hearth_quench_hit.wav.m4a": "dNDf3dbR",
  "audio/hearth_quench_hit.wav.ogg": "PsTXo6t9",
  "audio/hearth_spark_cast.wav.m4a": "5cImNbCa",
  "audio/hearth_spark_cast.wav.ogg": "eDC0R3Mw",
  "audio/hearth_spark_hit.wav.m4a": "PrwbaJ52",
  "audio/hearth_spark_hit.wav.ogg": "Y6pgsVbf",
  "audio/hearth_vow_cast.wav.m4a": "YaYmLudT",
  "audio/hearth_vow_cast.wav.ogg": "vWJaxK3p",
  "audio/hearth_vow_hit.wav.m4a": "e5RIP0QX",
  "audio/hearth_vow_hit.wav.ogg": "SDpdICPc",
  "audio/hind_call.wav.m4a": "kfk5zmYR",
  "audio/hind_call.wav.ogg": "N8RkP2lO",
  "audio/hind_hit.wav.m4a": "f7djaUdE",
  "audio/hind_hit.wav.ogg": "MlGCg8eK",
  "audio/hind_horn.wav.m4a": "tb-NdMIY",
  "audio/hind_horn.wav.ogg": "mL7YhZbh",
  "audio/hit.wav.m4a": "qWrNCWPj",
  "audio/hit.wav.ogg": "76GAw38B",
  "audio/holy_bless.wav.m4a": "qpEB-1ew",
  "audio/holy_bless.wav.ogg": "JqpRK9MK",
  "audio/holy_bless_hit.wav.m4a": "w2YvmcJP",
  "audio/holy_bless_hit.wav.ogg": "Azud71cs",
  "audio/holy_cast.wav.m4a": "hDhy_I75",
  "audio/holy_cast.wav.ogg": "c61MHDRl",
  "audio/holy_charge.wav.m4a": "l6-BHlIt",
  "audio/holy_charge.wav.ogg": "SANvg55d",
  "audio/holy_cleanse.wav.m4a": "rq36DOOl",
  "audio/holy_cleanse.wav.ogg": "v-5BCOnD",
  "audio/holy_cleanse_hit.wav.m4a": "gx22pJfD",
  "audio/holy_cleanse_hit.wav.ogg": "UZmm1Ivh",
  "audio/holy_dome.wav.m4a": "gu8_tFXi",
  "audio/holy_dome.wav.ogg": "K1dqRT1V",
  "audio/holy_hand_cast.wav.m4a": "aQI5kzrB",
  "audio/holy_hand_cast.wav.ogg": "VSFP9uBi",
  "audio/holy_hand_hit.wav.m4a": "4VG7czvZ",
  "audio/holy_hand_hit.wav.ogg": "1ksVjig4",
  "audio/holy_heal_cast.wav.m4a": "7tA1j2ob",
  "audio/holy_heal_cast.wav.ogg": "Ha3PN20U",
  "audio/holy_heal_hit.wav.m4a": "ha7FnDKp",
  "audio/holy_heal_hit.wav.ogg": "8zKB9m6b",
  "audio/holy_hit.wav.m4a": "TsNjINOW",
  "audio/holy_hit.wav.ogg": "h2mgeogy",
  "audio/holy_mantle.wav.m4a": "N7yuLk9T",
  "audio/holy_mantle.wav.ogg": "7kY5VV5Y",
  "audio/holy_mantle_hit.wav.m4a": "D0kDdu3t",
  "audio/holy_mantle_hit.wav.ogg": "boM2pS0P",
  "audio/holy_might.wav.m4a": "Pnm4pPrX",
  "audio/holy_might.wav.ogg": "b28aX8Oq",
  "audio/holy_might_hit.wav.m4a": "TWCSFbht",
  "audio/holy_might_hit.wav.ogg": "lT2HHA5p",
  "audio/holy_nova.wav.m4a": "O0ZPCgSG",
  "audio/holy_nova.wav.ogg": "A1hfQ52v",
  "audio/holy_nova_cast.wav.m4a": "vjppsftZ",
  "audio/holy_nova_cast.wav.ogg": "nuTnIcgy",
  "audio/holy_pace.wav.m4a": "HsODg9z_",
  "audio/holy_pace.wav.ogg": "54AAOXi7",
  "audio/holy_pace_hit.wav.m4a": "vrg4vXJv",
  "audio/holy_pace_hit.wav.ogg": "pW3wqyeH",
  "audio/holy_pulse_cast.wav.m4a": "FVR4sBQz",
  "audio/holy_pulse_cast.wav.ogg": "vgsA6mLF",
  "audio/holy_pulse_hit.wav.m4a": "gtfCTAlF",
  "audio/holy_pulse_hit.wav.ogg": "prxWq6jr",
  "audio/holy_smite_cast.wav.m4a": "4YwnXHBA",
  "audio/holy_smite_cast.wav.ogg": "Vsm9KB3H",
  "audio/holy_smite_hit.wav.m4a": "Y0GkBkEW",
  "audio/holy_smite_hit.wav.ogg": "Gj5xJ_mv",
  "audio/holy_ward.wav.m4a": "pfdGwMek",
  "audio/holy_ward.wav.ogg": "M2UPPbBp",
  "audio/hunter_chase.wav.m4a": "HuhoeL8K",
  "audio/hunter_chase.wav.ogg": "iW_Fke9J",
  "audio/hunter_draw.wav.m4a": "RYvERYal",
  "audio/hunter_draw.wav.ogg": "qPawYuHn",
  "audio/hunter_hamstring.wav.m4a": "co0x_-mx",
  "audio/hunter_hamstring.wav.ogg": "dEYcySzy",
  "audio/hunter_hamstring_hit.wav.m4a": "sloAPeE8",
  "audio/hunter_hamstring_hit.wav.ogg": "hRtl4-r8",
  "audio/hunter_heavy.wav.m4a": "2FucaZfO",
  "audio/hunter_heavy.wav.ogg": "QctXvUE9",
  "audio/hunter_heavy_hit.wav.m4a": "EHGlGLIX",
  "audio/hunter_heavy_hit.wav.ogg": "8_Mi1pg_",
  "audio/hunter_leap.wav.m4a": "W2Scj37i",
  "audio/hunter_leap.wav.ogg": "wQVU4B9K",
  "audio/hunter_prey.wav.m4a": "BcXYVjnw",
  "audio/hunter_prey.wav.ogg": "-18QPG5H",
  "audio/hunter_prey_hit.wav.m4a": "RySuqbxX",
  "audio/hunter_prey_hit.wav.ogg": "3qbq2FZu",
  "audio/ice_spikes.wav.m4a": "dN-TlMer",
  "audio/ice_spikes.wav.ogg": "LGCG3hQE",
  "audio/keeper_bark_cast.wav.m4a": "xmv3svsi",
  "audio/keeper_bark_cast.wav.ogg": "5yeQnNH4",
  "audio/keeper_bark_hit.wav.m4a": "hkffdbdc",
  "audio/keeper_bark_hit.wav.ogg": "FVRH52E1",
  "audio/keeper_breath_cast.wav.m4a": "MfTitgkz",
  "audio/keeper_breath_cast.wav.ogg": "P8V4NeCW",
  "audio/keeper_breath_hit.wav.m4a": "2BHY9u7u",
  "audio/keeper_breath_hit.wav.ogg": "BI43AKhl",
  "audio/keeper_dew_cast.wav.m4a": "X2tkexcm",
  "audio/keeper_dew_cast.wav.ogg": "z-PHBqKc",
  "audio/keeper_dew_hit.wav.m4a": "oQb5f83B",
  "audio/keeper_dew_hit.wav.ogg": "ztVDEY2N",
  "audio/keeper_root_cast.wav.m4a": "HbeaDN4r",
  "audio/keeper_root_cast.wav.ogg": "HJ617M0P",
  "audio/keeper_root_hit.wav.m4a": "MTzq_K5K",
  "audio/keeper_root_hit.wav.ogg": "BfF_m-Gt",
  "audio/keeper_thicket_cast.wav.m4a": "s3yWzE0O",
  "audio/keeper_thicket_cast.wav.ogg": "QmP9n4hs",
  "audio/keeper_thicket_hit.wav.m4a": "SR0_ahvL",
  "audio/keeper_thicket_hit.wav.ogg": "IcQTLhja",
  "audio/keeper_vines_cast.wav.m4a": "aLgxzz8X",
  "audio/keeper_vines_cast.wav.ogg": "XVt9yOx6",
  "audio/keeper_vines_hit.wav.m4a": "AEty8D0o",
  "audio/keeper_vines_hit.wav.ogg": "vXcpxhz0",
  "audio/knight_bash.wav.m4a": "kxXLqVwR",
  "audio/knight_bash.wav.ogg": "ynWMHXPW",
  "audio/knight_bash_hit.wav.m4a": "DITtMM7v",
  "audio/knight_bash_hit.wav.ogg": "UyIYGcnC",
  "audio/knight_bastion.wav.m4a": "b58j6x__",
  "audio/knight_bastion.wav.ogg": "o4r0-dHf",
  "audio/knight_guard.wav.m4a": "Ap5w6Uw-",
  "audio/knight_guard.wav.ogg": "k-AestX_",
  "audio/knight_smash.wav.m4a": "hclyAjdf",
  "audio/knight_smash.wav.ogg": "iXOoaWY1",
  "audio/knight_smash_hit.wav.m4a": "Eq9l67bz",
  "audio/knight_smash_hit.wav.ogg": "zv81w2wF",
  "audio/knight_taunt.wav.m4a": "E9yfxFwi",
  "audio/knight_taunt.wav.ogg": "W7XaFXPJ",
  "audio/level_up.wav.m4a": "Ntp74i4R",
  "audio/level_up.wav.ogg": "MwCEsXlU",
  "audio/lever.wav.m4a": "v6RSPMrh",
  "audio/lever.wav.ogg": "s0PbczMZ",
  "audio/marble_chisel.wav.m4a": "mzbPLDyO",
  "audio/marble_chisel.wav.ogg": "M_asAV_M",
  "audio/marble_growl.wav.m4a": "d-5mbrpR",
  "audio/marble_growl.wav.ogg": "_1Fifx-K",
  "audio/marble_hit.wav.m4a": "0B9A9OSC",
  "audio/marble_hit.wav.ogg": "eu2X_Bgw",
  "audio/marks_crack.wav.m4a": "vi7O9RLV",
  "audio/marks_crack.wav.ogg": "nS36TH2w",
  "audio/marks_draw.wav.m4a": "HqXRnF_e",
  "audio/marks_draw.wav.ogg": "3woUMWNN",
  "audio/marks_knock.wav.m4a": "B0v3_Ztq",
  "audio/marks_knock.wav.ogg": "dwWehKMC",
  "audio/marks_knock_draw.wav.m4a": "Oqk49Tfe",
  "audio/marks_knock_draw.wav.ogg": "HUzZTjQd",
  "audio/marks_knock_hit.wav.m4a": "v6dw5T9j",
  "audio/marks_knock_hit.wav.ogg": "N8f4Py0l",
  "audio/marks_plate.wav.m4a": "FsbcIAL3",
  "audio/marks_plate.wav.ogg": "3J777B6w",
  "audio/marks_prep.wav.m4a": "ETxT-LI6",
  "audio/marks_prep.wav.ogg": "YS97AHMf",
  "audio/marks_snipe.wav.m4a": "9s9kV_Hd",
  "audio/marks_snipe.wav.ogg": "-KtXiwWE",
  "audio/marks_stance.wav.m4a": "qd_8_2P2",
  "audio/marks_stance.wav.ogg": "RKm1jZnz",
  "audio/mob_death.wav.m4a": "4DS-4MIW",
  "audio/mob_death.wav.ogg": "Eyclzac4",
  "audio/music/city.wav.m4a": "r-QsmL0z",
  "audio/music/city.wav.ogg": "Szs4aX3k",
  "audio/music/combat.mp3.m4a": "w2d6k5T2",
  "audio/music/combat.mp3.ogg": "k4_2ETWB",
  "audio/music/combat.wav.m4a": "dygIFnzc",
  "audio/music/combat.wav.ogg": "oPAWAWVA",
  "audio/music/danger.wav.m4a": "j9sc_Q2L",
  "audio/music/danger.wav.ogg": "jYh4STHr",
  "audio/music/death.mp3.m4a": "6sN0D8sx",
  "audio/music/death.mp3.ogg": "FWzvvpyO",
  "audio/music/mire.wav.m4a": "jo_S7ZIA",
  "audio/music/mire.wav.ogg": "AloN6_UI",
  "audio/music/select.mp3.m4a": "2O_y7oPJ",
  "audio/music/select.mp3.ogg": "kMQ6dauW",
  "audio/music/select.wav.m4a": "Qc2Y-Ed6",
  "audio/music/select.wav.ogg": "ufouY11H",
  "audio/music/village.wav.m4a": "PUJzmtSp",
  "audio/music/village.wav.ogg": "xkGNrzJU",
  "audio/music/wild.mp3.m4a": "wRhVxXTT",
  "audio/music/wild.mp3.ogg": "tpQNI43-",
  "audio/music/wild.wav.m4a": "avXY5990",
  "audio/music/wild.wav.ogg": "IavXGuZ-",
  "audio/music/грустная.mp3.m4a": "6sN0D8sx",
  "audio/music/грустная.mp3.ogg": "qiKAfD68",
  "audio/music/лесная боевая.mp3.m4a": "w2d6k5T2",
  "audio/music/лесная боевая.mp3.ogg": "sxEjXCCq",
  "audio/music/лесная деревня.mp3.m4a": "wRhVxXTT",
  "audio/music/лесная деревня.mp3.ogg": "tcSi7jGy",
  "audio/music/лунные мечты.mp3.m4a": "2O_y7oPJ",
  "audio/music/лунные мечты.mp3.ogg": "HQUsOu4Z",
  "audio/night_strike.wav.m4a": "JNoeMh-K",
  "audio/night_strike.wav.ogg": "faoF5-O7",
  "audio/ord_brace.wav.m4a": "kbJb4PYH",
  "audio/ord_brace.wav.ogg": "k5OmUNi-",
  "audio/ord_breach.wav.m4a": "YVgHKyzb",
  "audio/ord_breach.wav.ogg": "NUS1uC33",
  "audio/ord_breach_heavy.wav.m4a": "0RGxSPwj",
  "audio/ord_breach_heavy.wav.ogg": "6FqopHcP",
  "audio/ord_shatter.wav.m4a": "hHXhZ7oT",
  "audio/ord_shatter.wav.ogg": "alDHpAxt",
  "audio/pun_kill.wav.m4a": "P6glD5v9",
  "audio/pun_kill.wav.ogg": "yRRbntrM",
  "audio/pun_mark.wav.m4a": "cspduhAv",
  "audio/pun_mark.wav.ogg": "nj1yHWIy",
  "audio/pun_verdict.wav.m4a": "520thghn",
  "audio/pun_verdict.wav.ogg": "4pdp1q67",
  "audio/pun_verdict_heavy.wav.m4a": "pJjgKUrD",
  "audio/pun_verdict_heavy.wav.ogg": "bmYWmyoV",
  "audio/pyro_cast.wav.m4a": "lBgEFWjP",
  "audio/pyro_cast.wav.ogg": "oVsvD8uG",
  "audio/pyro_heart.wav.m4a": "PaXfdUkG",
  "audio/pyro_heart.wav.ogg": "KEPBzeoB",
  "audio/pyro_pillar.wav.m4a": "LPZTAg1c",
  "audio/pyro_pillar.wav.ogg": "RHtZ40wE",
  "audio/pyro_pulse.wav.m4a": "Mi1mKEy8",
  "audio/pyro_pulse.wav.ogg": "5q5SlEaQ",
  "audio/pyro_ring.wav.m4a": "X02PMxLY",
  "audio/pyro_ring.wav.ogg": "9ALqbsZg",
  "audio/pyro_sparks.wav.m4a": "TJJvA1TK",
  "audio/pyro_sparks.wav.ogg": "xZr7-3_7",
  "audio/pyro_storm.wav.m4a": "Fc7zdJh4",
  "audio/pyro_storm.wav.ogg": "tIIVN8Dz",
  "audio/rattler_hiss.wav.m4a": "sKZwS7lJ",
  "audio/rattler_hiss.wav.ogg": "YrMgv1vN",
  "audio/rattler_hit.wav.m4a": "g1eVllUn",
  "audio/rattler_hit.wav.ogg": "p69wQttN",
  "audio/rattler_strike.wav.m4a": "ejChylI3",
  "audio/rattler_strike.wav.ogg": "FZrBFfE0",
  "audio/revive.wav.m4a": "uEJr5AqO",
  "audio/revive.wav.ogg": "pGgZDffQ",
  "audio/rune_aegis_cast.wav.m4a": "LIGIK5bb",
  "audio/rune_aegis_cast.wav.ogg": "_Kn80AjI",
  "audio/rune_aegis_hit.wav.m4a": "y0RNLL0P",
  "audio/rune_aegis_hit.wav.ogg": "YtPUCPgu",
  "audio/rune_bind_cast.wav.m4a": "In9B83zr",
  "audio/rune_bind_cast.wav.ogg": "AVF5F8Jv",
  "audio/rune_bind_hit.wav.m4a": "8RAgIs0W",
  "audio/rune_bind_hit.wav.ogg": "v43eHpQ_",
  "audio/rune_bless.wav.m4a": "bjJifCfx",
  "audio/rune_bless.wav.ogg": "mifCiMEw",
  "audio/rune_bless_hit.wav.m4a": "lCR7mqbl",
  "audio/rune_bless_hit.wav.ogg": "Uj26NxKD",
  "audio/rune_brand_hit.wav.m4a": "LjZNPG1n",
  "audio/rune_brand_hit.wav.ogg": "TercSmSp",
  "audio/rune_break.wav.m4a": "ZxXfmy0X",
  "audio/rune_break.wav.ogg": "kn4UrMPt",
  "audio/rune_burst_cast.wav.m4a": "ochyFadI",
  "audio/rune_burst_cast.wav.ogg": "FIO5to2a",
  "audio/rune_burst_hit.wav.m4a": "ARGP8jv4",
  "audio/rune_burst_hit.wav.ogg": "j8gGy51u",
  "audio/rune_cast.wav.m4a": "G-4q-Ouq",
  "audio/rune_cast.wav.ogg": "wzVM7xu3",
  "audio/rune_charge.wav.m4a": "ZgdB89VW",
  "audio/rune_charge.wav.ogg": "jE-wbEVr",
  "audio/rune_cleanse.wav.m4a": "xKjhuxpM",
  "audio/rune_cleanse.wav.ogg": "59TGg3BK",
  "audio/rune_cleanse_hit.wav.m4a": "n6wNqe9o",
  "audio/rune_cleanse_hit.wav.ogg": "rbz5dUm7",
  "audio/rune_crack_cast.wav.m4a": "rf0hhfII",
  "audio/rune_crack_cast.wav.ogg": "L5uPcrFt",
  "audio/rune_crack_hit.wav.m4a": "_x8EHmk9",
  "audio/rune_crack_hit.wav.ogg": "CYPF9AVq",
  "audio/rune_dome.wav.m4a": "ZchAKUVF",
  "audio/rune_dome.wav.ogg": "fRjpzQZr",
  "audio/rune_hand_cast.wav.m4a": "MLhNkBkV",
  "audio/rune_hand_cast.wav.ogg": "qFfyjtih",
  "audio/rune_hand_hit.wav.m4a": "QQIX6rCz",
  "audio/rune_hand_hit.wav.ogg": "vHe4IuBn",
  "audio/rune_heal_cast.wav.m4a": "ZpnI2a0Y",
  "audio/rune_heal_cast.wav.ogg": "bu7B0HsA",
  "audio/rune_heal_hit.wav.m4a": "qSdL4UpH",
  "audio/rune_heal_hit.wav.ogg": "2bv-xGPv",
  "audio/rune_hit.wav.m4a": "uDcaFZ2O",
  "audio/rune_hit.wav.ogg": "23I5_LiU",
  "audio/rune_nova.wav.m4a": "CbOzadRs",
  "audio/rune_nova.wav.ogg": "syKN1cOy",
  "audio/rune_oath_cast.wav.m4a": "kNwUqOWZ",
  "audio/rune_oath_cast.wav.ogg": "VQct5cBs",
  "audio/rune_oath_hit.wav.m4a": "M7I5nqg1",
  "audio/rune_oath_hit.wav.ogg": "A5jjX7i2",
  "audio/rune_pulse_cast.wav.m4a": "fCDTWzlG",
  "audio/rune_pulse_cast.wav.ogg": "BgOQfjC4",
  "audio/rune_pulse_hit.wav.m4a": "h50bn1fm",
  "audio/rune_pulse_hit.wav.ogg": "d_AAEAN4",
  "audio/rune_smite_cast.wav.m4a": "NnWk2vVn",
  "audio/rune_smite_cast.wav.ogg": "qi29se2E",
  "audio/rune_smite_hit.wav.m4a": "Yvw1tRdg",
  "audio/rune_smite_hit.wav.ogg": "UWqm6jGd",
  "audio/rune_ward.wav.m4a": "5V3K_c_4",
  "audio/rune_ward.wav.ogg": "B85pOk8N",
  "audio/rune_ward_cast.wav.m4a": "ia2nuRvM",
  "audio/rune_ward_cast.wav.ogg": "0kPPG463",
  "audio/rune_ward_hit.wav.m4a": "YxrEAhre",
  "audio/rune_ward_hit.wav.ogg": "ltu4AGkY",
  "audio/slag_hit.wav.m4a": "pCCf1mHY",
  "audio/slag_hit.wav.ogg": "TJVO8CiW",
  "audio/slag_swing.wav.m4a": "q0UNnuYa",
  "audio/slag_swing.wav.ogg": "hfdYes6-",
  "audio/soul_cast.wav.m4a": "jfbyMcrg",
  "audio/soul_cast.wav.ogg": "KWTfeWHV",
  "audio/soul_death.wav.m4a": "czYPHHv4",
  "audio/soul_death.wav.ogg": "zEAAqB1J",
  "audio/soul_hit.wav.m4a": "xtxb_WfN",
  "audio/soul_hit.wav.ogg": "WTSzJE-P",
  "audio/spark_aggro.wav.m4a": "xbQ_KPsZ",
  "audio/spark_aggro.wav.ogg": "MJJBEPCJ",
  "audio/spark_death.wav.m4a": "r-wbuYvH",
  "audio/spark_death.wav.ogg": "HwwK5rEP",
  "audio/spark_hit.wav.m4a": "Ka_fXZFz",
  "audio/spark_hit.wav.ogg": "diEWfCB8",
  "audio/spark_swing.wav.m4a": "zXbfaKpX",
  "audio/spark_swing.wav.ogg": "IJousAwh",
  "audio/stone_avalanche.wav.m4a": "mahCZGDl",
  "audio/stone_avalanche.wav.ogg": "0kNAxAd1",
  "audio/stone_avalanche_cast.wav.m4a": "UONk4ySN",
  "audio/stone_avalanche_cast.wav.ogg": "bULRg_oi",
  "audio/stone_boulder.wav.m4a": "RVUHU1Z9",
  "audio/stone_boulder.wav.ogg": "ptJoNVHp",
  "audio/stone_boulder_charge.wav.m4a": "hOnB5ruZ",
  "audio/stone_boulder_charge.wav.ogg": "fpP0HdzG",
  "audio/stone_boulder_hit.wav.m4a": "aoQrSN9N",
  "audio/stone_boulder_hit.wav.ogg": "RZT55AMN",
  "audio/stone_boulder_shot.wav.m4a": "Y0IXRJO3",
  "audio/stone_boulder_shot.wav.ogg": "qv8NmFou",
  "audio/stone_cast.wav.m4a": "Qw0_rsyT",
  "audio/stone_cast.wav.ogg": "2sPkX027",
  "audio/stone_hit.wav.m4a": "Qw2IyGR7",
  "audio/stone_hit.wav.ogg": "yPbwy35e",
  "audio/stone_petrify.wav.m4a": "UJ3fypw9",
  "audio/stone_petrify.wav.ogg": "JDXFxjwD",
  "audio/stone_quake.wav.m4a": "F4jVdrWi",
  "audio/stone_quake.wav.ogg": "Eb1duqmu",
  "audio/stone_shard.wav.m4a": "6q3MMzHF",
  "audio/stone_shard.wav.ogg": "tfDcgOyH",
  "audio/stone_shard_charge.wav.m4a": "Iu5V1yaZ",
  "audio/stone_shard_charge.wav.ogg": "jPoSxyf8",
  "audio/stone_shard_hit.wav.m4a": "XLUI8NRE",
  "audio/stone_shard_hit.wav.ogg": "sxUMdevU",
  "audio/stone_skin.wav.m4a": "TaNf99MD",
  "audio/stone_skin.wav.ogg": "D0bWQgLA",
  "audio/storm_calm.wav.m4a": "zFRrATUU",
  "audio/storm_calm.wav.ogg": "gMBj1vn9",
  "audio/storm_cast.wav.m4a": "0tvzJBkd",
  "audio/storm_cast.wav.ogg": "8gd3KDXY",
  "audio/storm_crit.wav.m4a": "SewmEhJJ",
  "audio/storm_crit.wav.ogg": "FzcL3e7F",
  "audio/storm_hit.wav.m4a": "5YyGLzFc",
  "audio/storm_hit.wav.ogg": "x5d98xnY",
  "audio/storm_hurricane.wav.m4a": "LCPOxM-w",
  "audio/storm_hurricane.wav.ogg": "9qjchFRu",
  "audio/storm_hurricane_cast.wav.m4a": "yOKBp2AZ",
  "audio/storm_hurricane_cast.wav.ogg": "6YaFm0hV",
  "audio/storm_orb.wav.m4a": "grnffrF_",
  "audio/storm_orb.wav.ogg": "kGA3nZST",
  "audio/storm_orb_charge.wav.m4a": "l0IVJKi3",
  "audio/storm_orb_charge.wav.ogg": "a8JB4baa",
  "audio/storm_orb_hit.wav.m4a": "-q5hLUgs",
  "audio/storm_orb_hit.wav.ogg": "JIfjU85C",
  "audio/storm_squall.wav.m4a": "zrBBUOew",
  "audio/storm_squall.wav.ogg": "g9AWi17G",
  "audio/storm_veil.wav.m4a": "04-5UWFm",
  "audio/storm_veil.wav.ogg": "rC23TV-m",
  "audio/sword_hit.wav.m4a": "IhK1t-Jg",
  "audio/sword_hit.wav.ogg": "CebqfGIj",
  "audio/sword_swing.wav.m4a": "mgRYSLTp",
  "audio/sword_swing.wav.ogg": "AJkujYJL",
  "audio/tide_fall.wav.m4a": "kwIiqTjZ",
  "audio/tide_fall.wav.ogg": "g_IG57D5",
  "audio/tide_fall_cast.wav.m4a": "L4mSvJOE",
  "audio/tide_fall_cast.wav.ogg": "u7n2v8T2",
  "audio/tide_fall_hit.wav.m4a": "WEt_NLEw",
  "audio/tide_fall_hit.wav.ogg": "_S9krPdb",
  "audio/tide_glide.wav.m4a": "XLGr1mDX",
  "audio/tide_glide.wav.ogg": "gEf2v0Cw",
  "audio/tide_orb.wav.m4a": "NqRj0rCH",
  "audio/tide_orb.wav.ogg": "cv4q4JsT",
  "audio/tide_orb_charge.wav.m4a": "avZkpoSg",
  "audio/tide_orb_charge.wav.ogg": "z42RNhgs",
  "audio/tide_orb_hit.wav.m4a": "FQZv_I1L",
  "audio/tide_orb_hit.wav.ogg": "eXdfqHSe",
  "audio/tide_repel.wav.m4a": "4PBQ02TJ",
  "audio/tide_repel.wav.ogg": "Gc3nNjXE",
  "audio/tide_surf.wav.m4a": "iRhsdJmW",
  "audio/tide_surf.wav.ogg": "gBftqPf4",
  "audio/tide_surf_burst.wav.m4a": "MtAoAu-I",
  "audio/tide_surf_burst.wav.ogg": "iB9OiZ2T",
  "audio/tide_surf_hit.wav.m4a": "O_CpJx0a",
  "audio/tide_surf_hit.wav.ogg": "zDF-OBGA",
  "audio/tide_vortex.wav.m4a": "TAZQOH5a",
  "audio/tide_vortex.wav.ogg": "cAeiDqTa",
  "audio/tide_vortex_cast.wav.m4a": "APaZnIzx",
  "audio/tide_vortex_cast.wav.ogg": "ChdyjtkW",
  "audio/tide_vortex_hit.wav.m4a": "CUoUOHi8",
  "audio/tide_vortex_hit.wav.ogg": "xQygfNxa",
  "audio/tide_wave.wav.m4a": "miIjTFdK",
  "audio/tide_wave.wav.ogg": "9qtswFI1",
  "audio/tide_wave_hit.wav.m4a": "HflE8dii",
  "audio/tide_wave_hit.wav.ogg": "d2SaS70B",
  "audio/tide_wave_roll.wav.m4a": "nbdcWSY6",
  "audio/tide_wave_roll.wav.ogg": "5ucJd3o7",
  "audio/toad_croak.wav.m4a": "6xsJRXVG",
  "audio/toad_croak.wav.ogg": "_hnudjsM",
  "audio/toad_gulp.wav.m4a": "cfQ0O0IE",
  "audio/toad_gulp.wav.ogg": "zpgeFS8D",
  "audio/toad_hit.wav.m4a": "QLOOhosl",
  "audio/toad_hit.wav.ogg": "K2fTWc81",
  "audio/topiary_hit.wav.m4a": "QAlXvpd0",
  "audio/topiary_hit.wav.ogg": "s2KZ_484",
  "audio/topiary_rustle.wav.m4a": "0DKB4Gqd",
  "audio/topiary_rustle.wav.ogg": "69ycupyF",
  "audio/topiary_shear.wav.m4a": "sMd5Ucve",
  "audio/topiary_shear.wav.ogg": "i9ia1UM_",
  "audio/travel_in.wav.m4a": "oRlYYsIH",
  "audio/travel_in.wav.ogg": "rRzufaRN",
  "audio/travel_out.wav.m4a": "4t-F7NwX",
  "audio/travel_out.wav.ogg": "ZtUzb7Pm",
  "audio/twin_hit.wav.m4a": "0iojEYNv",
  "audio/twin_hit.wav.ogg": "uMp_K4TV",
  "audio/twin_swing.wav.m4a": "dT0aob9b",
  "audio/twin_swing.wav.ogg": "F7SFJ4up",
  "audio/ui_enchant_success.wav.m4a": "7g9RjSMw",
  "audio/ui_enchant_success.wav.ogg": "ionqwWWx",
  "audio/ui_enter_world.wav.m4a": "NFrDCKAf",
  "audio/ui_enter_world.wav.ogg": "f2iwbVw8",
  "audio/ui_error.wav.m4a": "mdb3EGAG",
  "audio/ui_error.wav.ogg": "SCNY7Yh3",
  "audio/ui_jewel_cut.wav.m4a": "HuWV3wYl",
  "audio/ui_jewel_cut.wav.ogg": "8pM6PYEa",
  "audio/ui_jewel_extract.wav.m4a": "7L88zgZ1",
  "audio/ui_jewel_extract.wav.ogg": "In0mgmsS",
  "audio/ui_jewel_insert.wav.m4a": "sQ3WT1Pn",
  "audio/ui_jewel_insert.wav.ogg": "yDIzxpJl",
  "audio/ui_jewel_replace.wav.m4a": "CFlsx_iB",
  "audio/ui_jewel_replace.wav.ogg": "UrMmdCxb",
  "audio/ui_login_success.wav.m4a": "GpLri3uj",
  "audio/ui_login_success.wav.ogg": "6n_RNfQw",
  "audio/voevoda_bash.wav.m4a": "MdQT2Esx",
  "audio/voevoda_bash.wav.ogg": "U6Zs5Pja",
  "audio/voevoda_cut.wav.m4a": "hLMM7-nT",
  "audio/voevoda_cut.wav.ogg": "IwUuMxNE",
  "audio/voevoda_hit.wav.m4a": "SKnKSE7F",
  "audio/voevoda_hit.wav.ogg": "t38ombni",
  "audio/voevoda_press.wav.m4a": "wbx78ouh",
  "audio/voevoda_press.wav.ogg": "s6-9En2c",
  "audio/voevoda_roar.wav.m4a": "jCQEj7iJ",
  "audio/voevoda_roar.wav.ogg": "--b7vM1c",
  "audio/water_glide.wav.m4a": "l1fshHrm",
  "audio/water_glide.wav.ogg": "azZKXDcQ",
  "audio/water_hit.wav.m4a": "5nnzcBUY",
  "audio/water_hit.wav.ogg": "T2Tjd0Kj",
  "audio/wolf_hit.mp3.m4a": "Omkxm7DJ",
  "audio/wolf_hit.mp3.ogg": "tCEx-q-Q",
  "audio/wolf_swing.wav.m4a": "MhyCnKUN",
  "audio/wolf_swing.wav.ogg": "rYRUjLAQ",
  "brand/apple-touch-180.png": "nDAVkbYn",
  "brand/create-stage.jpg": "3Blp1eLS",
  "brand/create-stage.jpg.webp": "7rIb4uE4",
  "brand/favicon-192.png": "-7ANms61",
  "brand/favicon-32.png": "rZZfVlnS",
  "brand/frame9-c-bl.png": "4sFOGqju",
  "brand/frame9-c-bl.png.webp": "5FOm-FDE",
  "brand/frame9-c-br.png": "7gpnxMpp",
  "brand/frame9-c-br.png.webp": "ro6p5SMI",
  "brand/frame9-c-tl.png": "ozlnKl3a",
  "brand/frame9-c-tl.png.webp": "WomEo6Mj",
  "brand/frame9-c-tr.png": "PgeUbxwQ",
  "brand/frame9-c-tr.png.webp": "M8L2usF9",
  "brand/frame9-e-b.png": "pZbShks8",
  "brand/frame9-e-b.png.webp": "vKQeIrIy",
  "brand/frame9-e-l.png": "R2zrJhdD",
  "brand/frame9-e-l.png.webp": "duDHTN29",
  "brand/frame9-e-r.png": "16fVOR0Y",
  "brand/frame9-e-r.png.webp": "gJnhp9B8",
  "brand/frame9-e-t.png": "8rnQmySK",
  "brand/frame9-e-t.png.webp": "pQvxn2eP",
  "brand/frame9-g-b.png": "O_CwTZtJ",
  "brand/frame9-g-b.png.webp": "rzLXU3qy",
  "brand/frame9-g-l.png": "ZaGDVMSu",
  "brand/frame9-g-l.png.webp": "Ov1mcbSb",
  "brand/frame9-g-r.png": "mcDgAU3d",
  "brand/frame9-g-r.png.webp": "itCAoS8p",
  "brand/frame9-g-t.png": "NTU7nokg",
  "brand/frame9-g-t.png.webp": "LxAq5CSU",
  "brand/loading-gate-v.jpg": "yBiThjMw",
  "brand/loading-gate-v.jpg.webp": "kRwEcUeu",
  "brand/loading-gate.jpg": "vTcoHfb0",
  "brand/loading-gate.jpg.webp": "wKrz1fkE",
  "brand/loading-war-v.jpg": "4TDg1SVu",
  "brand/loading-war-v.jpg.webp": "mg9dM1aQ",
  "brand/loading-war.jpg": "2_4u629T",
  "brand/loading-war.jpg.webp": "zmN56hdg",
  "brand/login-art-v.jpg": "RxEKTVya",
  "brand/login-art-v.jpg.webp": "gxUQSiKB",
  "brand/login-art.jpg": "Rt0c5SYA",
  "brand/login-art.jpg.webp": "JJ-ikkEi",
  "brand/pwa-512.png": "XTZnMeR6",
  "brand/stage-select-v.jpg": "D1QUbDnX",
  "brand/stage-select-v.jpg.webp": "kNeVduDj",
  "brand/stage-select.jpg": "h2q1wIXb",
  "brand/stage-select.jpg.webp": "5CkaZVsX",
  "brand/ui-frame.png": "qem0ExCb",
  "brand/ui-frame.png.webp": "KT8u5P1M",
  "brand/ui-ribbon.png": "k7nX8xPL",
  "brand/ui-ribbon.png.webp": "ziELDhY8",
  "brand/ui-standard-v.png": "iSjzw3Nw",
  "brand/ui-standard-v.png.webp": "VKy-kcU3",
  "dungeons/crypt_daily.png": "vDLJDgqr",
  "dungeons/ember_forge_daily.png": "PvsSCro7",
  "dungeons/tutorial_grounds.png": "8NFhQ8qE",
  "icons/abilities/abyss_deep.svg": "4Q89jO24",
  "icons/abilities/abyss_drain.svg": "oZEjr05P",
  "icons/abilities/abyss_greed.svg": "_L4l39Sm",
  "icons/abilities/abyss_harvest.svg": "_Eg2HlTn",
  "icons/abilities/abyss_heart.svg": "sm4H5ePj",
  "icons/abilities/abyss_mark.svg": "_O2h2q_x",
  "icons/abilities/abyss_mind.svg": "BTyGWmz-",
  "icons/abilities/abyss_orb.svg": "AhkvQnFA",
  "icons/abilities/abyss_pact.svg": "Oe-ieZFZ",
  "icons/abilities/abyss_rot.svg": "ypF4qdLh",
  "icons/abilities/abyss_silence.svg": "apnD46PY",
  "icons/abilities/abyss_whisper.svg": "wkYZ_m_a",
  "icons/abilities/bear_rage.svg": "E5mSLG8Q",
  "icons/abilities/berserk_across.svg": "UNzmD8B_",
  "icons/abilities/berserk_breath.svg": "1ttYD3UQ",
  "icons/abilities/berserk_chop.svg": "3NIkePAF",
  "icons/abilities/berserk_deep.svg": "S3wjBtwS",
  "icons/abilities/berserk_gulp.svg": "2wCLyq4r",
  "icons/abilities/berserk_hand.svg": "optZQZrM",
  "icons/abilities/berserk_hide.svg": "8VTzaXed",
  "icons/abilities/berserk_meat.svg": "asfN9IuX",
  "icons/abilities/berserk_rage.svg": "ssW4XBZV",
  "icons/abilities/berserk_step.svg": "jra4a-MH",
  "icons/abilities/berserk_throat.svg": "sPAY2iqP",
  "icons/abilities/berserk_wide.svg": "u3w6f_Iu",
  "icons/abilities/bishop_ascension.svg": "WS-jnj9w",
  "icons/abilities/bishop_heal.svg": "zvR6M3ow",
  "icons/abilities/bishop_mantle.svg": "F-mYY9hJ",
  "icons/abilities/bishop_might.svg": "I4M-giEI",
  "icons/abilities/bishop_nova.svg": "RHjm-xBg",
  "icons/abilities/bishop_pace.svg": "xaV0lQlo",
  "icons/abilities/bishop_passive_authority.svg": "dD-O4Dl7",
  "icons/abilities/bishop_passive_light.svg": "oW1F0pde",
  "icons/abilities/bishop_presence.svg": "N3gHiaLq",
  "icons/abilities/bishop_verdict.svg": "haqfIvXv",
  "icons/abilities/cleric_cleanse.svg": "IWNdqagk",
  "icons/abilities/cleric_hand.svg": "WZBXSv9V",
  "icons/abilities/cleric_haven.svg": "DzEFpb3g",
  "icons/abilities/cleric_heal.svg": "5fWhTuEH",
  "icons/abilities/cleric_mercy_strike.svg": "kJYWLFGn",
  "icons/abilities/cleric_miracle.svg": "2siZSVy6",
  "icons/abilities/cleric_passive_faith.svg": "wkLrNRDJ",
  "icons/abilities/cleric_passive_grace.svg": "qTzbCkfG",
  "icons/abilities/cleric_shield.svg": "LUeQnBwj",
  "icons/abilities/cleric_smite.svg": "a6_3aSj9",
  "icons/abilities/cross.svg": "1Bkc5n5X",
  "icons/abilities/dance_blades.svg": "j8KLjtcc",
  "icons/abilities/dance_breath.svg": "5e1-vyMS",
  "icons/abilities/dance_cascade.svg": "tiT-I5Rm",
  "icons/abilities/dance_deep.svg": "6COKoy6j",
  "icons/abilities/dance_edge.svg": "Kh93_k-c",
  "icons/abilities/dance_fan.svg": "sdAADNAl",
  "icons/abilities/dance_glide.svg": "vp5usvkn",
  "icons/abilities/dance_mirage.svg": "1G15aSZX",
  "icons/abilities/dance_poise.svg": "MGC62MCn",
  "icons/abilities/dance_rend.svg": "PcS2ylWp",
  "icons/abilities/dance_rhythm.svg": "uWmHgEAg",
  "icons/abilities/dark_agility.svg": "1mPwTt_1",
  "icons/abilities/dark_blight.svg": "o_W3A7bm",
  "icons/abilities/dark_blood.svg": "ZTDzADf0",
  "icons/abilities/dark_dose.svg": "p7JPXlav",
  "icons/abilities/dark_eye.svg": "KSwnUhVU",
  "icons/abilities/dark_numb.svg": "iPcuvTVR",
  "icons/abilities/dark_rot.svg": "SM12rec8",
  "icons/abilities/dark_step.svg": "_nb4StUI",
  "icons/abilities/dark_thick.svg": "m7kBqYeH",
  "icons/abilities/dark_tips.svg": "e45tpLxA",
  "icons/abilities/dark_venom.svg": "bT-9Du5f",
  "icons/abilities/death_dance.svg": "ilsutWAz",
  "icons/abilities/death_execute.svg": "N8wbMIbF",
  "icons/abilities/death_precision.svg": "imC7nRpc",
  "icons/abilities/duel_parry.svg": "3lPKoy0q",
  "icons/abilities/duel_reflect.svg": "lWIIiw65",
  "icons/abilities/duel_steel.svg": "NMLaiqDC",
  "icons/abilities/dusk_coldblood.svg": "Gz-TvIh1",
  "icons/abilities/dusk_edge.svg": "LYBuKb77",
  "icons/abilities/dusk_fan.svg": "7AHSDMYU",
  "icons/abilities/dusk_glide.svg": "hnziAzLJ",
  "icons/abilities/dusk_lethal.svg": "suBGanRa",
  "icons/abilities/dusk_measured.svg": "D43xyTkM",
  "icons/abilities/dusk_open.svg": "HTjadVsF",
  "icons/abilities/dusk_patience.svg": "PH9yhgue",
  "icons/abilities/dusk_perfect.svg": "ximO17Z0",
  "icons/abilities/dusk_precise.svg": "d4WXfqHL",
  "icons/abilities/dusk_recoil.svg": "jMSIVOJg",
  "icons/abilities/dwarf_rune_mastery.svg": "NRmddO6L",
  "icons/abilities/earthquake.svg": "pocG5Npa",
  "icons/abilities/elf_barbs.svg": "8hBbznwb",
  "icons/abilities/elf_cover.svg": "ohFywzsT",
  "icons/abilities/elf_eye.svg": "5ATv6gKC",
  "icons/abilities/elf_fletch.svg": "RxP3AU3T",
  "icons/abilities/elf_heart.svg": "zEoDsSun",
  "icons/abilities/elf_hush.svg": "5xIR4h6h",
  "icons/abilities/elf_last.svg": "UNKryWaQ",
  "icons/abilities/elf_leap.svg": "4kcckjo7",
  "icons/abilities/elf_mark.svg": "vNJCKA2z",
  "icons/abilities/elf_song.svg": "XnqVAxN7",
  "icons/abilities/elf_tremor.svg": "IzF1gfsJ",
  "icons/abilities/ember_lash.svg": "csYpSWSU",
  "icons/abilities/fire_cloak.svg": "SH-6rDbl",
  "icons/abilities/fire_storm.svg": "AMi-2JQH",
  "icons/abilities/fireball.svg": "QIRXkY3Z",
  "icons/abilities/flame_blood.svg": "S5-0MiJY",
  "icons/abilities/flame_bonfire.svg": "1WiwlzpQ",
  "icons/abilities/flame_clash.svg": "BtRlsetZ",
  "icons/abilities/flame_dash.svg": "gK5E1all",
  "icons/abilities/flame_fist.svg": "8Sf3lOtw",
  "icons/abilities/flame_heart.svg": "tO903ebs",
  "icons/abilities/flame_heat.svg": "QB-jrvZ1",
  "icons/abilities/flame_long.svg": "LynYQeCR",
  "icons/abilities/flame_might.svg": "x3_6PXNI",
  "icons/abilities/flame_pillar.svg": "EJS_uDkS",
  "icons/abilities/flame_rage.svg": "AfnSeKah",
  "icons/abilities/flame_series.svg": "MmsAvS0a",
  "icons/abilities/flame_strike.svg": "7gjwF4ZL",
  "icons/abilities/forge_call.svg": "BA0plNfA",
  "icons/abilities/forge_chest.svg": "k03QHP-3",
  "icons/abilities/forge_cling.svg": "7u3wHg34",
  "icons/abilities/forge_dense.svg": "QXyExnBi",
  "icons/abilities/forge_flat.svg": "6smOcqpr",
  "icons/abilities/forge_might.svg": "Ca3Huuc7",
  "icons/abilities/forge_plate.svg": "RFS4MyA0",
  "icons/abilities/forge_rim.svg": "MBpwbzFt",
  "icons/abilities/forge_root.svg": "Srvoauk_",
  "icons/abilities/forge_scale.svg": "WJMJcHsl",
  "icons/abilities/forge_stance.svg": "NwNrlGwE",
  "icons/abilities/forge_strike.svg": "H8Ov9qlE",
  "icons/abilities/forge_wall.svg": "XAkKXSIQ",
  "icons/abilities/geyser.svg": "aKQ-Ndfu",
  "icons/abilities/glad_arena.svg": "kDFEiJca",
  "icons/abilities/glad_blood_execute.svg": "-aZiNs7b",
  "icons/abilities/glad_blood_rend.svg": "W0nY-pB4",
  "icons/abilities/glad_cleave.svg": "NvsVxqcz",
  "icons/abilities/glad_passive_fury.svg": "2SzBVm5G",
  "icons/abilities/glad_passive_steel.svg": "qS_8QOiL",
  "icons/abilities/glad_rush.svg": "H2qzBmTh",
  "icons/abilities/glad_strike.svg": "9nBI_NiA",
  "icons/abilities/glad_trail.svg": "rdSw4Wyk",
  "icons/abilities/glad_warcry.svg": "wIaLZMUc",
  "icons/abilities/glad_whirl_spin.svg": "aYDQq9Nc",
  "icons/abilities/glad_whirl_storm.svg": "zfu6su0q",
  "icons/abilities/hammer_anvil.svg": "cxW_m_9J",
  "icons/abilities/hammer_arc.svg": "iH0fpxLG",
  "icons/abilities/hammer_deaf.svg": "yuhIULd1",
  "icons/abilities/hammer_fell.svg": "YoGNaVcL",
  "icons/abilities/hammer_hearth.svg": "3arMpGG-",
  "icons/abilities/hammer_helm.svg": "6cWDZT9S",
  "icons/abilities/hammer_peak.svg": "RlCSX6Zq",
  "icons/abilities/hammer_pin.svg": "YJ5lps5N",
  "icons/abilities/hammer_shoulder.svg": "wXTgM25k",
  "icons/abilities/hammer_smith.svg": "D-UwC6j3",
  "icons/abilities/hammer_strike.svg": "EW5h_sGJ",
  "icons/abilities/hammer_weight.svg": "IrCQUneG",
  "icons/abilities/hearth_core.svg": "FvIOG2YG",
  "icons/abilities/hearth_edge.svg": "zoyvQvyg",
  "icons/abilities/hearth_heart.svg": "3pEz2f0A",
  "icons/abilities/hearth_keen.svg": "Y386PSZk",
  "icons/abilities/hearth_mail.svg": "rZ9ctM0N",
  "icons/abilities/hearth_passive_anvil.svg": "IQnxm0I_",
  "icons/abilities/hearth_passive_bellows.svg": "BponhoLN",
  "icons/abilities/hearth_quench.svg": "0dO0pjQP",
  "icons/abilities/hearth_rhythm.svg": "eyWeKGz0",
  "icons/abilities/hearth_spark.svg": "CpCnHQW2",
  "icons/abilities/hearth_vow.svg": "yLo7PgTu",
  "icons/abilities/holy_bless.svg": "TI4ozJW8",
  "icons/abilities/ice_spikes.svg": "zT4rlAUI",
  "icons/abilities/keeper_bark.svg": "vokxnCAa",
  "icons/abilities/keeper_breath.svg": "lH0pzv2s",
  "icons/abilities/keeper_dew.svg": "4kJ0G4YV",
  "icons/abilities/keeper_heart.svg": "_Mb5zJw9",
  "icons/abilities/keeper_passive_bind.svg": "iEtjkPa9",
  "icons/abilities/keeper_passive_vein.svg": "Ann0Au7v",
  "icons/abilities/keeper_root.svg": "xS_ZdZxW",
  "icons/abilities/keeper_skin.svg": "NIzQIipz",
  "icons/abilities/keeper_thicket.svg": "Xt_jlg3P",
  "icons/abilities/keeper_vines.svg": "_fqIaN-Q",
  "icons/abilities/keeper_wrath.svg": "tWPf1RQf",
  "icons/abilities/knight_bash.svg": "EZI90lhU",
  "icons/abilities/knight_bastion.svg": "xkygvzLD",
  "icons/abilities/knight_bulwark.svg": "7ukYiB28",
  "icons/abilities/knight_guard.svg": "X71YfzlL",
  "icons/abilities/knight_order.svg": "Uw9ctX4-",
  "icons/abilities/knight_passive_plate.svg": "4X82JX4V",
  "icons/abilities/knight_passive_vow.svg": "tNcIfSpN",
  "icons/abilities/knight_reflect.svg": "pqwtp-YT",
  "icons/abilities/knight_ring.svg": "MW2dA1_q",
  "icons/abilities/knight_smash.svg": "nbsSAhWV",
  "icons/abilities/knight_stun.svg": "x-cqw7qC",
  "icons/abilities/knight_taunt.svg": "FWaVbTku",
  "icons/abilities/marks_chain.svg": "IAEREQRZ",
  "icons/abilities/marks_cold.svg": "vY86xXAb",
  "icons/abilities/marks_knock.svg": "H6oajnLK",
  "icons/abilities/marks_legend.svg": "rzm47IoP",
  "icons/abilities/marks_passive_aim.svg": "EjaWB626",
  "icons/abilities/marks_passive_draw.svg": "LXQ4O0xL",
  "icons/abilities/marks_prepare.svg": "sYexPWrb",
  "icons/abilities/marks_retreat.svg": "9OxFbmCY",
  "icons/abilities/marks_snipe.svg": "d_2Lkps9",
  "icons/abilities/marks_stance.svg": "yBQltRuv",
  "icons/abilities/marks_steady.svg": "-Du2fmW_",
  "icons/abilities/night_cold.svg": "Iu-Jtd0h",
  "icons/abilities/night_harvest.svg": "BlILD7ki",
  "icons/abilities/night_strike.svg": "JrZamjzT",
  "icons/abilities/ord_bodkin.svg": "xtb_v2hT",
  "icons/abilities/ord_breach.svg": "dPZ36RDZ",
  "icons/abilities/ord_passive_drill.svg": "CeCSEvO9",
  "icons/abilities/pun_finisher.svg": "HrXEhZdE",
  "icons/abilities/pun_passive_sentence.svg": "6bclSa_D",
  "icons/abilities/pun_verdict.svg": "hkSyBalR",
  "icons/abilities/pyro_ash_armor.svg": "5Yks6wo1",
  "icons/abilities/pyro_bolt.svg": "pJ0UivmH",
  "icons/abilities/pyro_burn.svg": "JTRx8QN9",
  "icons/abilities/pyro_forge.svg": "75_gyNAI",
  "icons/abilities/pyro_heart.svg": "X6_X7tu-",
  "icons/abilities/pyro_passive_heat.svg": "U8a03Z4S",
  "icons/abilities/pyro_pillar.svg": "ODQ-QhLs",
  "icons/abilities/pyro_ring.svg": "Iphvi8oT",
  "icons/abilities/pyro_scorch.svg": "SjvyZsiY",
  "icons/abilities/pyro_smolder.svg": "e482-NAf",
  "icons/abilities/pyro_sparks.svg": "rBIuJhwK",
  "icons/abilities/rune_aegis.svg": "WgMxJ1C5",
  "icons/abilities/rune_bind.svg": "QAYDmOUf",
  "icons/abilities/rune_burst.svg": "Il3GjQhK",
  "icons/abilities/rune_crack.svg": "4fK7UkR7",
  "icons/abilities/rune_etch.svg": "GH7zGQRM",
  "icons/abilities/rune_heart.svg": "6CD2f46Q",
  "icons/abilities/rune_mend.svg": "v-hVo-yk",
  "icons/abilities/rune_oath.svg": "nttQ5C75",
  "icons/abilities/rune_passive_cut.svg": "ZSoNJIgu",
  "icons/abilities/rune_passive_stone.svg": "Iw8evz1N",
  "icons/abilities/rune_ward.svg": "_1AtuZ3D",
  "icons/abilities/scout_bow.svg": "27s6hcjL",
  "icons/abilities/scout_chase.svg": "pslDmFoJ",
  "icons/abilities/scout_eye.svg": "9rE0V6b-",
  "icons/abilities/scout_hamstring.svg": "hDn6TyBZ",
  "icons/abilities/scout_leap.svg": "4rZcmWt0",
  "icons/abilities/scout_predator.svg": "jp9YtN-j",
  "icons/abilities/scout_prey.svg": "T89Ou2Lr",
  "icons/abilities/scout_prey_shot.svg": "YDddqku_",
  "icons/abilities/scout_sticky.svg": "IIuRPIgW",
  "icons/abilities/scout_trail.svg": "wAK4tH5h",
  "icons/abilities/scout_vanish.svg": "g3K-aEkM",
  "icons/abilities/shot.svg": "KzUnnoa3",
  "icons/abilities/slash.svg": "JIuq3zKd",
  "icons/abilities/stone_avalanche.svg": "RouwpA2P",
  "icons/abilities/stone_blood.svg": "cxzRnp0p",
  "icons/abilities/stone_boulder.svg": "5tUoojtA",
  "icons/abilities/stone_flesh.svg": "Etzcj0VF",
  "icons/abilities/stone_granite.svg": "_pdg6oyn",
  "icons/abilities/stone_heart.svg": "RBAIhYnn",
  "icons/abilities/stone_might.svg": "lnoXrui8",
  "icons/abilities/stone_petrify.svg": "spTmlsw6",
  "icons/abilities/stone_shard.svg": "HWlIaWuF",
  "icons/abilities/stone_shot.svg": "yrxcfNCJ",
  "icons/abilities/stone_skin.svg": "ujbojS-1",
  "icons/abilities/stone_spike.svg": "vpIg5I5h",
  "icons/abilities/stone_weight.svg": "5mZ9WFRi",
  "icons/abilities/storm_calm.svg": "dwt-Xynt",
  "icons/abilities/storm_eye.svg": "nx0CEsph",
  "icons/abilities/storm_heart.svg": "wMcZN-9t",
  "icons/abilities/storm_hurricane.svg": "FTcDlSDG",
  "icons/abilities/storm_mind.svg": "IoC2dkdt",
  "icons/abilities/storm_orb.svg": "LTjhHXS0",
  "icons/abilities/storm_peal.svg": "Pedlbumc",
  "icons/abilities/storm_squall.svg": "wSbcv1Gq",
  "icons/abilities/storm_static.svg": "BZKy9U7x",
  "icons/abilities/storm_still.svg": "T133wra4",
  "icons/abilities/storm_thunder.svg": "rhAUBa-3",
  "icons/abilities/storm_veil.svg": "J4qUpnJx",
  "icons/abilities/tree_elder.svg": "rN-Opx3T",
  "icons/abilities/tree_gift.svg": "0Doh8TEF",
  "icons/abilities/tree_heartwood.svg": "eSXCqVmE",
  "icons/abilities/tree_one.svg": "MgZl6B2q",
  "icons/abilities/tree_passive_longevity.svg": "OJawYDPk",
  "icons/abilities/tree_passive_wisdom.svg": "fcn20w0_",
  "icons/abilities/tree_pollen.svg": "Qt6J4M-j",
  "icons/abilities/tree_ray.svg": "zGUfGrkc",
  "icons/abilities/tree_sap.svg": "65PDvLPa",
  "icons/abilities/tree_seed.svg": "7GL8jhcT",
  "icons/abilities/tree_spring.svg": "601yMQE8",
  "icons/abilities/twin_slash.svg": "_dzUSrjo",
  "icons/abilities/voevoda_bash.svg": "csc549J2",
  "icons/abilities/voevoda_chest.svg": "yeuxcur7",
  "icons/abilities/voevoda_chief.svg": "DMfvvtAo",
  "icons/abilities/voevoda_cut.svg": "vTOpE4BP",
  "icons/abilities/voevoda_deaf.svg": "iMedZZ-d",
  "icons/abilities/voevoda_fear.svg": "8gvFbggI",
  "icons/abilities/voevoda_follow.svg": "KX-CTzR8",
  "icons/abilities/voevoda_press.svg": "C05lEtwg",
  "icons/abilities/voevoda_roar.svg": "B9zQmMoa",
  "icons/abilities/voevoda_shield.svg": "-3fmC223",
  "icons/abilities/voevoda_stay.svg": "XlmW245y",
  "icons/abilities/voevoda_wide.svg": "LaMa1o_q",
  "icons/abilities/water_bolt.svg": "y3HrHosn",
  "icons/abilities/water_fall.svg": "ZruV3ujj",
  "icons/abilities/water_glide.svg": "nb7mAU1L",
  "icons/abilities/water_heavy.svg": "cF6G78sX",
  "icons/abilities/water_orb.svg": "8epvt7HJ",
  "icons/abilities/water_passive_depth.svg": "TSdUfG3H",
  "icons/abilities/water_passive_flow.svg": "rk9Zxxjk",
  "icons/abilities/water_repel.svg": "dcpTLJgM",
  "icons/abilities/water_spray.svg": "LUkX5PtQ",
  "icons/abilities/water_surf.svg": "J8xpiULG",
  "icons/abilities/water_tides.svg": "NulAAEkZ",
  "icons/abilities/water_vortex.svg": "CxWe9quH",
  "icons/abilities/water_wave.svg": "DX4e29Cr",
  "icons/abilities/wind_cutting.svg": "g3qH5Fev",
  "icons/abilities/wind_storm.svg": "avF1E5Bg",
  "icons/abilities/wind_whirl.svg": "oVfqr5nA",
  "icons/buffs/clan_academy_blessing.svg": "ADGHGBeJ",
  "icons/buffs/clan_body.svg": "pMXUNK4f",
  "icons/buffs/clan_cadet.svg": "9QrA1xZ1",
  "icons/buffs/clan_might.svg": "ib9KlaJ_",
  "icons/buffs/clan_solidarity.svg": "xUrRvWtU",
  "icons/buffs/clan_ward.svg": "j1LE04W4",
  "icons/hud/campaign-chevron.svg": "RoBvuELL",
  "icons/hud/campaign-journal.svg": "tnDL91_t",
  "icons/hud/class/1.svg": "K7Haag4Q",
  "icons/hud/class/2.svg": "dFNnRqDp",
  "icons/hud/class/3.svg": "uxUZsOba",
  "icons/hud/class/4.svg": "Btr5R-_O",
  "icons/hud/gender/1.svg": "vCnA_yNz",
  "icons/hud/gender/2.svg": "yU9ewQom",
  "icons/hud/profession/1.svg": "YL4PSuUi",
  "icons/hud/profession/10.svg": "44gU_mLN",
  "icons/hud/profession/100.svg": "TCjth_Rg",
  "icons/hud/profession/100_1.svg": "NgK1a92I",
  "icons/hud/profession/100_3.svg": "0GPFLEAq",
  "icons/hud/profession/101.svg": "fxP5qRLz",
  "icons/hud/profession/101_1.svg": "I4l83yFx",
  "icons/hud/profession/101_3.svg": "Q3b5Ej0a",
  "icons/hud/profession/102.svg": "ov2ExQ1C",
  "icons/hud/profession/102_1.svg": "8JeeQ340",
  "icons/hud/profession/102_3.svg": "7LlvDUy7",
  "icons/hud/profession/102_5.svg": "Kg3ziMBo",
  "icons/hud/profession/103.svg": "1kaJIdo6",
  "icons/hud/profession/103_1.svg": "2q9PHZIQ",
  "icons/hud/profession/103_3.svg": "JRATGLeH",
  "icons/hud/profession/103_5.svg": "W2IKRlF2",
  "icons/hud/profession/104.svg": "LtORI-o2",
  "icons/hud/profession/104_5.svg": "gjagMK8P",
  "icons/hud/profession/105.svg": "Lwgnz0g6",
  "icons/hud/profession/105_5.svg": "DrTtF2p7",
  "icons/hud/profession/10_1.svg": "Dk_o-5_O",
  "icons/hud/profession/10_4.svg": "F4_I40fD",
  "icons/hud/profession/10_5.svg": "9oCVII0R",
  "icons/hud/profession/11.svg": "AG39wlPH",
  "icons/hud/profession/110.svg": "y4DNK8BA",
  "icons/hud/profession/110_1.svg": "sqX5Pvts",
  "icons/hud/profession/110_4.svg": "sKTvBlSq",
  "icons/hud/profession/110_5.svg": "cA5TLMdZ",
  "icons/hud/profession/111.svg": "vjwPQSRc",
  "icons/hud/profession/111_1.svg": "QFISyefF",
  "icons/hud/profession/111_4.svg": "96-VWUIn",
  "icons/hud/profession/111_5.svg": "C17hV9G4",
  "icons/hud/profession/112.svg": "AD_jZW-x",
  "icons/hud/profession/112_1.svg": "IvJTRLWk",
  "icons/hud/profession/112_4.svg": "RQWIlap8",
  "icons/hud/profession/112_5.svg": "zeWTWImA",
  "icons/hud/profession/113.svg": "-HT3L1aw",
  "icons/hud/profession/113_1.svg": "x2FBU2Hg",
  "icons/hud/profession/113_4.svg": "FmR6uFqP",
  "icons/hud/profession/113_5.svg": "XwVV8dqO",
  "icons/hud/profession/11_1.svg": "LPvgaxFz",
  "icons/hud/profession/11_4.svg": "kJokRC9N",
  "icons/hud/profession/11_5.svg": "Hr5U38kH",
  "icons/hud/profession/120.svg": "X31vZ9pJ",
  "icons/hud/profession/120_1.svg": "2HTB3vaO",
  "icons/hud/profession/120_2.svg": "T8e2sNPj",
  "icons/hud/profession/120_3.svg": "_BsQu2YG",
  "icons/hud/profession/121.svg": "qZgYrgB6",
  "icons/hud/profession/121_1.svg": "ZVxkhi2T",
  "icons/hud/profession/121_2.svg": "QWt-Qc6V",
  "icons/hud/profession/121_3.svg": "M3AHBDk0",
  "icons/hud/profession/122.svg": "sxPr44FJ",
  "icons/hud/profession/122_1.svg": "oqy2fEcH",
  "icons/hud/profession/122_2.svg": "_2QmikjJ",
  "icons/hud/profession/122_3.svg": "4RXToOJx",
  "icons/hud/profession/123.svg": "Ary8RTiA",
  "icons/hud/profession/123_1.svg": "FGRMPr4h",
  "icons/hud/profession/123_2.svg": "aevbfA-A",
  "icons/hud/profession/123_3.svg": "3J9yWe51",
  "icons/hud/profession/130.svg": "SkDIXjFP",
  "icons/hud/profession/130_1.svg": "aAPFKgdd",
  "icons/hud/profession/130_2.svg": "E00tsvua",
  "icons/hud/profession/130_4.svg": "58x9Q9DR",
  "icons/hud/profession/131.svg": "9Y0N00AF",
  "icons/hud/profession/131_1.svg": "6G7AMYE4",
  "icons/hud/profession/131_2.svg": "mRklJckm",
  "icons/hud/profession/131_4.svg": "8mnM3yyY",
  "icons/hud/profession/132.svg": "UGx8H-AH",
  "icons/hud/profession/132_1.svg": "_7pR7-5f",
  "icons/hud/profession/132_2.svg": "psgfYvCe",
  "icons/hud/profession/132_4.svg": "rCSKvUUe",
  "icons/hud/profession/133.svg": "uOpxrDdw",
  "icons/hud/profession/133_1.svg": "0ULM2Q6e",
  "icons/hud/profession/133_2.svg": "MsfAO85x",
  "icons/hud/profession/133_4.svg": "hiq_n1p-",
  "icons/hud/profession/1_1.svg": "Az_c705E",
  "icons/hud/profession/1_3.svg": "WUIpjrvq",
  "icons/hud/profession/2.svg": "x04f_bRy",
  "icons/hud/profession/20.svg": "BSYAPBFZ",
  "icons/hud/profession/20_1.svg": "Du28hRX6",
  "icons/hud/profession/20_2.svg": "gDeljxSp",
  "icons/hud/profession/20_3.svg": "YveprZ_u",
  "icons/hud/profession/21.svg": "FSqPdB_k",
  "icons/hud/profession/21_1.svg": "7xFEJFP0",
  "icons/hud/profession/21_2.svg": "rbTuYVIf",
  "icons/hud/profession/21_3.svg": "jCmn3Amy",
  "icons/hud/profession/2_1.svg": "hYuM4Nxl",
  "icons/hud/profession/2_3.svg": "7-_z2qbh",
  "icons/hud/profession/2_5.svg": "43QRKSLf",
  "icons/hud/profession/3.svg": "dBNO_iv1",
  "icons/hud/profession/30.svg": "AXMikQE8",
  "icons/hud/profession/30_1.svg": "cAs8VdcY",
  "icons/hud/profession/30_2.svg": "buzSh-vR",
  "icons/hud/profession/30_4.svg": "iv4HO_tc",
  "icons/hud/profession/31.svg": "WYyS7_b1",
  "icons/hud/profession/31_1.svg": "jdACol97",
  "icons/hud/profession/31_2.svg": "f8FNR6BX",
  "icons/hud/profession/31_4.svg": "kQ3nmUx4",
  "icons/hud/profession/3_5.svg": "RrMxJkfn",
  "icons/hud/race/1.svg": "m652wKEJ",
  "icons/hud/race/2.svg": "JL-WuT-3",
  "icons/hud/race/3.svg": "LP3gv71X",
  "icons/hud/race/4.svg": "7kIOvjVW",
  "icons/hud/race/5.svg": "beRedCki",
  "icons/items/bandit_token.svg": "CJVz5WNr",
  "icons/items/blades_pious_a.svg": "dKC1NGUA",
  "icons/items/blades_pious_b.svg": "kuz3arzy",
  "icons/items/blades_pious_c.svg": "wdze8zXJ",
  "icons/items/blades_pious_s.svg": "Q8UZPb7w",
  "icons/items/blades_t3.svg": "FpkJBPcN",
  "icons/items/blades_t5.svg": "fWdDet9S",
  "icons/items/blades_t7.svg": "hAZwV1ux",
  "icons/items/blades_t9.svg": "ce9ehM4D",
  "icons/items/boar_tag.svg": "BtyfoEev",
  "icons/items/boots_pious_a.svg": "t1X4L5C0",
  "icons/items/boots_pious_b.svg": "7_IEjKEo",
  "icons/items/boots_pious_c.svg": "PXtDFg6O",
  "icons/items/boots_pious_s.svg": "n4Rs8Wvt",
  "icons/items/boots_t10.svg": "ZhnOiqOt",
  "icons/items/boots_t2.svg": "MdDKrD2t",
  "icons/items/boots_t3.svg": "tl2l4deY",
  "icons/items/boots_t4.svg": "eMb_Q7EH",
  "icons/items/boots_t5.svg": "xjrKvQHm",
  "icons/items/boots_t6.svg": "S-F35TIV",
  "icons/items/boots_t7.svg": "cQMfMVPO",
  "icons/items/boots_t8.svg": "ExhqbI4_",
  "icons/items/boots_t9.svg": "g2SbvBz1",
  "icons/items/bow_pious_a.svg": "jIegxXKg",
  "icons/items/bow_pious_b.svg": "qu6EvMhM",
  "icons/items/bow_pious_c.svg": "AkHy-7fv",
  "icons/items/bow_pious_s.svg": "JZF0jb9b",
  "icons/items/bow_t10.svg": "33Ntfojk",
  "icons/items/bow_t2.svg": "1ljMyV5x",
  "icons/items/bow_t3.svg": "Q0BD0RJw",
  "icons/items/bow_t4.svg": "2VyjGlw4",
  "icons/items/bow_t5.svg": "lL8JnNo2",
  "icons/items/bow_t6.svg": "TxP1XFGU",
  "icons/items/bow_t7.svg": "b0ODFhdz",
  "icons/items/bow_t8.svg": "jWs1L7CE",
  "icons/items/bow_t9.svg": "go_3CR5n",
  "icons/items/byakugan.png": "372p5bTl",
  "icons/items/byakugan.svg": "J3RYnBFw",
  "icons/items/camp_jerkin.svg": "ha2BeFuh",
  "icons/items/chest_pious_a.svg": "J4FPjvWG",
  "icons/items/chest_pious_b.svg": "Ht7WsI_Z",
  "icons/items/chest_pious_c.svg": "nnGj-KFk",
  "icons/items/chest_pious_s.svg": "JHW5nk7r",
  "icons/items/chest_premium_large.svg": "0wRbbERI",
  "icons/items/chest_premium_medium.svg": "j1eJg5U0",
  "icons/items/chest_premium_small.svg": "COwHXjFe",
  "icons/items/chest_t10.svg": "WrUCuqkl",
  "icons/items/chest_t2.svg": "r6A8Ms6Z",
  "icons/items/chest_t3.svg": "7_pvATvf",
  "icons/items/chest_t4.svg": "2GVpgIF6",
  "icons/items/chest_t5.svg": "YB2gDQQ6",
  "icons/items/chest_t6.svg": "BkFqx9B-",
  "icons/items/chest_t7.svg": "_aA7rpkC",
  "icons/items/chest_t8.svg": "A37cbH1i",
  "icons/items/chest_t9.svg": "fI7_lEbT",
  "icons/items/cloak_academy_grad.svg": "_1rfVM1Q",
  "icons/items/cloak_pious_a.svg": "vQOUbWI0",
  "icons/items/cloak_pious_b.svg": "1D9BqOAf",
  "icons/items/cloak_pious_c.svg": "tqG9Et3l",
  "icons/items/cloak_pious_s.svg": "bLrMCYbh",
  "icons/items/cloak_t3.svg": "jIs2QDoJ",
  "icons/items/cloak_t5.svg": "Px7Gh0wH",
  "icons/items/cloak_t7.svg": "NQwbNEU0",
  "icons/items/cloak_t9.svg": "96RBiWmr",
  "icons/items/coins_pack_16000.svg": "JkskXPep",
  "icons/items/coins_pack_3200.svg": "RKP8082K",
  "icons/items/coins_pack_36000.svg": "chQ_mkoY",
  "icons/items/coins_pack_7000.svg": "lbdI5DC3",
  "icons/items/coins_pack_720.svg": "C0-1Bd4x",
  "icons/items/cross_pious_a.svg": "FBiwqIaF",
  "icons/items/cross_pious_b.svg": "eUNZDEyg",
  "icons/items/cross_pious_c.svg": "J0lV6ykt",
  "icons/items/cross_pious_s.svg": "xhnzSWgp",
  "icons/items/cross_t10.svg": "7dWemfol",
  "icons/items/cross_t2.svg": "h_NBDjNG",
  "icons/items/cross_t3.svg": "lLXmMggk",
  "icons/items/cross_t4.svg": "Fbdr3WsB",
  "icons/items/cross_t5.svg": "-7B5WXmN",
  "icons/items/cross_t6.svg": "v18qkvm4",
  "icons/items/cross_t7.svg": "SkQDT_5O",
  "icons/items/cross_t8.svg": "ggNa4a4W",
  "icons/items/cross_t9.svg": "knQRV0ND",
  "icons/items/crystal.svg": "ALMPSBGi",
  "icons/items/crystal_a.svg": "NEXeS6--",
  "icons/items/crystal_b.svg": "vPLyPS6C",
  "icons/items/crystal_c.svg": "g0Z_gcyj",
  "icons/items/crystal_d.svg": "vICVJpp7",
  "icons/items/crystal_s.svg": "H9Fw6JvA",
  "icons/items/currency_royal_coin.svg": "5kxwWI54",
  "icons/items/ether.svg": "6ymU5WgR",
  "icons/items/eye_drops.svg": "Ir5wjcQW",
  "icons/items/eyes_common.svg": "t-NHVe0_",
  "icons/items/eyes_dark_elf.svg": "ANMtzWPb",
  "icons/items/eyes_darkvision.svg": "CBmvtzYy",
  "icons/items/eyes_dwarf.svg": "FbW3zndP",
  "icons/items/eyes_human.svg": "moUTdbGz",
  "icons/items/eyes_light_elf.svg": "GZTMcU18",
  "icons/items/eyes_orc.svg": "sCaGxxsA",
  "icons/items/food_grain.svg": "j0xzwLP8",
  "icons/items/food_stew.svg": "Rt0w5oHG",
  "icons/items/furn_bed.svg": "y8zm8oXT",
  "icons/items/furn_chair.svg": "_R_Qz1xc",
  "icons/items/furn_garden.svg": "eULJUiSP",
  "icons/items/furn_plant.svg": "0p_PvDaf",
  "icons/items/furn_stove.svg": "SAlGFZbZ",
  "icons/items/furn_table.svg": "tNgqpAQ4",
  "icons/items/gem.svg": "IQczhOdW",
  "icons/items/gloves_pious_a.svg": "JYcc3Fa_",
  "icons/items/gloves_pious_b.svg": "aPSs6FJ_",
  "icons/items/gloves_pious_c.svg": "YCst1pax",
  "icons/items/gloves_pious_s.svg": "sYO3nAW0",
  "icons/items/gloves_t10.svg": "PcgUe-65",
  "icons/items/gloves_t2.svg": "cS4p23OK",
  "icons/items/gloves_t3.svg": "dyp2-AGB",
  "icons/items/gloves_t4.svg": "ZDDvW6nJ",
  "icons/items/gloves_t5.svg": "FZw7lLBz",
  "icons/items/gloves_t6.svg": "6oigncok",
  "icons/items/gloves_t7.svg": "YvoMylwi",
  "icons/items/gloves_t8.svg": "q6mroDQ6",
  "icons/items/gloves_t9.svg": "7MDhYf_E",
  "icons/items/goods_electronic_part.svg": "dzTJDwhC",
  "icons/items/goods_metal_fitting.svg": "LTaLP3QY",
  "icons/items/hammer_pious_a.svg": "o8IiGtl_",
  "icons/items/hammer_pious_b.svg": "XkUT4aU-",
  "icons/items/hammer_pious_c.svg": "lp172cjD",
  "icons/items/hammer_pious_s.svg": "SE7RpkWn",
  "icons/items/hammer_t3.svg": "bxnAX4Ty",
  "icons/items/hammer_t5.svg": "KC4TWtql",
  "icons/items/hammer_t7.svg": "pqs-yRtH",
  "icons/items/hammer_t9.svg": "d_eu-G5A",
  "icons/items/helm_pious_a.svg": "qo_VewxD",
  "icons/items/helm_pious_b.svg": "7-0kA8Q6",
  "icons/items/helm_pious_c.svg": "9McIfv_q",
  "icons/items/helm_pious_s.svg": "1apiMLka",
  "icons/items/helm_t10.svg": "GyiM-sN6",
  "icons/items/helm_t2.svg": "XPUFytoZ",
  "icons/items/helm_t3.svg": "1mLFvaD1",
  "icons/items/helm_t4.svg": "2qZ7n7wx",
  "icons/items/helm_t5.svg": "1xaxHxO2",
  "icons/items/helm_t6.svg": "cfx0rxxk",
  "icons/items/helm_t7.svg": "pCLhaM-j",
  "icons/items/helm_t8.svg": "cRO1pDPw",
  "icons/items/helm_t9.svg": "lL3XecEk",
  "icons/items/herb_common.svg": "u7Brk-wH",
  "icons/items/herb_fine.svg": "Zn1ab__R",
  "icons/items/herb_pristine.svg": "nMRIh6sr",
  "icons/items/hide_common.svg": "vX-rc6ol",
  "icons/items/hide_fine.svg": "e7j1umD6",
  "icons/items/hide_pristine.svg": "6dVWxZuk",
  "icons/items/hunting_trophy.svg": "zcMP2qK4",
  "icons/items/jewel_amber_1.svg": "2aIOz2fG",
  "icons/items/jewel_amber_1_cut.svg": "o_nOazqs",
  "icons/items/jewel_amber_2.svg": "UYdKMwyE",
  "icons/items/jewel_amber_2_cut.svg": "-sGtAZJK",
  "icons/items/jewel_amber_3.svg": "NRJEjXJw",
  "icons/items/jewel_amber_3_cut.svg": "1Vu7eV09",
  "icons/items/jewel_amber_4.svg": "acLwZLv5",
  "icons/items/jewel_amber_4_cut.svg": "LZsY0Qxi",
  "icons/items/jewel_amber_5.svg": "vrAB_-5U",
  "icons/items/jewel_amber_5_cut.svg": "Fz6rTO1e",
  "icons/items/jewel_amber_g1.svg": "g-APc-C8",
  "icons/items/jewel_amber_g1_cut.svg": "EVJY_-bS",
  "icons/items/jewel_amber_g2.svg": "NQVxvfHL",
  "icons/items/jewel_amber_g2_cut.svg": "ODkSmuKS",
  "icons/items/jewel_amber_g3.svg": "UQIufVts",
  "icons/items/jewel_amber_g3_cut.svg": "les6WZq4",
  "icons/items/jewel_amber_g4.svg": "V2ZBtAhD",
  "icons/items/jewel_amber_g4_cut.svg": "HOBhYLCo",
  "icons/items/jewel_amber_g5.svg": "bXZkyaB0",
  "icons/items/jewel_amber_g5_cut.svg": "WP235vuO",
  "icons/items/jewel_amber_x.svg": "cqpR2agx",
  "icons/items/jewel_amber_x_cut.svg": "21sXNt7o",
  "icons/items/jewel_amethyst_1.svg": "ilLfCC4O",
  "icons/items/jewel_amethyst_1_cut.svg": "l5IoQ6eT",
  "icons/items/jewel_amethyst_2.svg": "4bnCqDYZ",
  "icons/items/jewel_amethyst_2_cut.svg": "FBLXQta0",
  "icons/items/jewel_amethyst_3.svg": "Y-YCRTGt",
  "icons/items/jewel_amethyst_3_cut.svg": "VWsWa5PW",
  "icons/items/jewel_amethyst_4.svg": "UCNEUGf5",
  "icons/items/jewel_amethyst_4_cut.svg": "roKaz8J2",
  "icons/items/jewel_amethyst_5.svg": "lC7OKuNg",
  "icons/items/jewel_amethyst_5_cut.svg": "hiv4uS2C",
  "icons/items/jewel_amethyst_g1.svg": "p_W2l3x6",
  "icons/items/jewel_amethyst_g1_cut.svg": "VLuhTvzB",
  "icons/items/jewel_amethyst_g2.svg": "6nIPt3sf",
  "icons/items/jewel_amethyst_g2_cut.svg": "ZKwEH-c1",
  "icons/items/jewel_amethyst_g3.svg": "rRROJzSO",
  "icons/items/jewel_amethyst_g3_cut.svg": "dUMPGVh5",
  "icons/items/jewel_amethyst_g4.svg": "nPyj-NNx",
  "icons/items/jewel_amethyst_g4_cut.svg": "TgSC70Z7",
  "icons/items/jewel_amethyst_g5.svg": "T-8Smree",
  "icons/items/jewel_amethyst_g5_cut.svg": "ANvdnM3R",
  "icons/items/jewel_amethyst_x.svg": "ZuW9skin",
  "icons/items/jewel_amethyst_x_cut.svg": "RUbsHvaf",
  "icons/items/jewel_aquamarine_1.svg": "FR1Lwa0s",
  "icons/items/jewel_aquamarine_1_cut.svg": "z54YxAtR",
  "icons/items/jewel_aquamarine_2.svg": "SDS8f5QZ",
  "icons/items/jewel_aquamarine_2_cut.svg": "bNXVmlnS",
  "icons/items/jewel_aquamarine_3.svg": "GM3MwLnm",
  "icons/items/jewel_aquamarine_3_cut.svg": "wU1Zslbk",
  "icons/items/jewel_aquamarine_4.svg": "MzgexesO",
  "icons/items/jewel_aquamarine_4_cut.svg": "S6g4i5Dq",
  "icons/items/jewel_aquamarine_5.svg": "W1YG2-53",
  "icons/items/jewel_aquamarine_5_cut.svg": "fGhQ9sMU",
  "icons/items/jewel_aquamarine_g1.svg": "OuisEqy-",
  "icons/items/jewel_aquamarine_g1_cut.svg": "t7shCLfY",
  "icons/items/jewel_aquamarine_g2.svg": "HKoo6elU",
  "icons/items/jewel_aquamarine_g2_cut.svg": "ldCPTxwT",
  "icons/items/jewel_aquamarine_g3.svg": "FNzEr3DY",
  "icons/items/jewel_aquamarine_g3_cut.svg": "1vnIY4K8",
  "icons/items/jewel_aquamarine_g4.svg": "qy5f4LMK",
  "icons/items/jewel_aquamarine_g4_cut.svg": "g0u2Xi6d",
  "icons/items/jewel_aquamarine_g5.svg": "NPErdcXA",
  "icons/items/jewel_aquamarine_g5_cut.svg": "bplyTVKb",
  "icons/items/jewel_aquamarine_x.svg": "v7AFJ9yg",
  "icons/items/jewel_aquamarine_x_cut.svg": "ssSvh1cG",
  "icons/items/jewel_cut_kit.svg": "J1loKI02",
  "icons/items/jewel_emerald_1.svg": "l5IVSnQj",
  "icons/items/jewel_emerald_1_cut.svg": "8L-sTKcU",
  "icons/items/jewel_emerald_2.svg": "XSUS9rDq",
  "icons/items/jewel_emerald_2_cut.svg": "fY5IWo9f",
  "icons/items/jewel_emerald_3.svg": "yuUa-TgV",
  "icons/items/jewel_emerald_3_cut.svg": "3wJG47dH",
  "icons/items/jewel_emerald_4.svg": "wbxw31XH",
  "icons/items/jewel_emerald_4_cut.svg": "EM50deMD",
  "icons/items/jewel_emerald_5.svg": "GGBc8RxQ",
  "icons/items/jewel_emerald_5_cut.svg": "qP_SoJbM",
  "icons/items/jewel_emerald_g1.svg": "7Dg7l6Zq",
  "icons/items/jewel_emerald_g1_cut.svg": "nogn1gV7",
  "icons/items/jewel_emerald_g2.svg": "wWVdvY0a",
  "icons/items/jewel_emerald_g2_cut.svg": "EHvibhdb",
  "icons/items/jewel_emerald_g3.svg": "Sb3F8woF",
  "icons/items/jewel_emerald_g3_cut.svg": "ifK4hYNt",
  "icons/items/jewel_emerald_g4.svg": "VnIE0w95",
  "icons/items/jewel_emerald_g4_cut.svg": "t6eiPEFe",
  "icons/items/jewel_emerald_g5.svg": "P479bMhz",
  "icons/items/jewel_emerald_g5_cut.svg": "gQRxiNr-",
  "icons/items/jewel_emerald_x.svg": "TDbgpN1a",
  "icons/items/jewel_emerald_x_cut.svg": "5I_Av-h5",
  "icons/items/jewel_extract_tool.svg": "73DF7ltY",
  "icons/items/jewel_onyx_1.svg": "ySTBfyuw",
  "icons/items/jewel_onyx_1_cut.svg": "kkH3n1SQ",
  "icons/items/jewel_onyx_2.svg": "flpHvcws",
  "icons/items/jewel_onyx_2_cut.svg": "BKRE1zih",
  "icons/items/jewel_onyx_3.svg": "D7Sz2CIm",
  "icons/items/jewel_onyx_3_cut.svg": "PfNpuDRj",
  "icons/items/jewel_onyx_4.svg": "a7zg4CcN",
  "icons/items/jewel_onyx_4_cut.svg": "_JhA1RU-",
  "icons/items/jewel_onyx_5.svg": "FabZynvU",
  "icons/items/jewel_onyx_5_cut.svg": "lsWTxUYT",
  "icons/items/jewel_onyx_g1.svg": "0iq8TSkP",
  "icons/items/jewel_onyx_g1_cut.svg": "R-p894r5",
  "icons/items/jewel_onyx_g2.svg": "W8lEhlp3",
  "icons/items/jewel_onyx_g2_cut.svg": "lK9Sg2a1",
  "icons/items/jewel_onyx_g3.svg": "QTLro3tR",
  "icons/items/jewel_onyx_g3_cut.svg": "0fuwpIEf",
  "icons/items/jewel_onyx_g4.svg": "4Hi2IRyo",
  "icons/items/jewel_onyx_g4_cut.svg": "F9fYk5Kk",
  "icons/items/jewel_onyx_g5.svg": "gXH-6Dav",
  "icons/items/jewel_onyx_g5_cut.svg": "W7REaHJ-",
  "icons/items/jewel_onyx_x.svg": "jceDSRAV",
  "icons/items/jewel_onyx_x_cut.svg": "gkLxNQBO",
  "icons/items/jewel_rainbow.svg": "OOibhUlc",
  "icons/items/jewel_rainbow_g.svg": "MiF2GAgC",
  "icons/items/jewel_rainbow_x.svg": "T1Mdf5PY",
  "icons/items/jewel_ruby_1.svg": "8PhxjbhC",
  "icons/items/jewel_ruby_1_cut.svg": "SMaqiwci",
  "icons/items/jewel_ruby_2.svg": "68NEJlFW",
  "icons/items/jewel_ruby_2_cut.svg": "yqW2fzAL",
  "icons/items/jewel_ruby_3.svg": "tHevIMss",
  "icons/items/jewel_ruby_3_cut.svg": "bU-6MGRI",
  "icons/items/jewel_ruby_4.svg": "6v_VXJV_",
  "icons/items/jewel_ruby_4_cut.svg": "gz0FdIKF",
  "icons/items/jewel_ruby_5.svg": "aIGJxUTK",
  "icons/items/jewel_ruby_5_cut.svg": "_l-iY-C1",
  "icons/items/jewel_ruby_g1.svg": "9F2kseem",
  "icons/items/jewel_ruby_g1_cut.svg": "X_2boloT",
  "icons/items/jewel_ruby_g2.svg": "SzuLs4WR",
  "icons/items/jewel_ruby_g2_cut.svg": "AsWcWnxH",
  "icons/items/jewel_ruby_g3.svg": "XHr5vL35",
  "icons/items/jewel_ruby_g3_cut.svg": "sdvt1Ji4",
  "icons/items/jewel_ruby_g4.svg": "XlCsvOKE",
  "icons/items/jewel_ruby_g4_cut.svg": "6wTz0nd8",
  "icons/items/jewel_ruby_g5.svg": "UXVQTcf8",
  "icons/items/jewel_ruby_g5_cut.svg": "LyU7e982",
  "icons/items/jewel_ruby_x.svg": "TIgaGDSV",
  "icons/items/jewel_ruby_x_cut.svg": "uQbOUWgP",
  "icons/items/jewel_sapphire_1.svg": "Wovxtmg0",
  "icons/items/jewel_sapphire_1_cut.svg": "SX91X59m",
  "icons/items/jewel_sapphire_2.svg": "oxyepcbx",
  "icons/items/jewel_sapphire_2_cut.svg": "VXGMMq6S",
  "icons/items/jewel_sapphire_3.svg": "75boO0-n",
  "icons/items/jewel_sapphire_3_cut.svg": "jBIJY24H",
  "icons/items/jewel_sapphire_4.svg": "hCxQeNOF",
  "icons/items/jewel_sapphire_4_cut.svg": "5sPbbIdo",
  "icons/items/jewel_sapphire_5.svg": "meiaDYKQ",
  "icons/items/jewel_sapphire_5_cut.svg": "__nVIDOo",
  "icons/items/jewel_sapphire_g1.svg": "cEGL2zTN",
  "icons/items/jewel_sapphire_g1_cut.svg": "nV9nI7bq",
  "icons/items/jewel_sapphire_g2.svg": "rajghHVe",
  "icons/items/jewel_sapphire_g2_cut.svg": "KkBSs__k",
  "icons/items/jewel_sapphire_g3.svg": "wYy_YPDU",
  "icons/items/jewel_sapphire_g3_cut.svg": "2x-29qud",
  "icons/items/jewel_sapphire_g4.svg": "IJMJYuhd",
  "icons/items/jewel_sapphire_g4_cut.svg": "xwWWnOvG",
  "icons/items/jewel_sapphire_g5.svg": "pql3CV3K",
  "icons/items/jewel_sapphire_g5_cut.svg": "BNp6fsZw",
  "icons/items/jewel_sapphire_x.svg": "_D9rQYzl",
  "icons/items/jewel_sapphire_x_cut.svg": "OSU3s3Dt",
  "icons/items/jewel_topaz_1.svg": "B6c9wfJj",
  "icons/items/jewel_topaz_1_cut.svg": "5iCb65ul",
  "icons/items/jewel_topaz_2.svg": "uX4LvYGz",
  "icons/items/jewel_topaz_2_cut.svg": "HzkiJmsL",
  "icons/items/jewel_topaz_3.svg": "8W_sT4WS",
  "icons/items/jewel_topaz_3_cut.svg": "osXyDPUA",
  "icons/items/jewel_topaz_4.svg": "vEip2mP9",
  "icons/items/jewel_topaz_4_cut.svg": "lIGokI81",
  "icons/items/jewel_topaz_5.svg": "iJPuxRJe",
  "icons/items/jewel_topaz_5_cut.svg": "5Y0mxJ2K",
  "icons/items/jewel_topaz_g1.svg": "Cs1tX-KA",
  "icons/items/jewel_topaz_g1_cut.svg": "oqaaWIgX",
  "icons/items/jewel_topaz_g2.svg": "3AXdqb7l",
  "icons/items/jewel_topaz_g2_cut.svg": "U_ReSn8x",
  "icons/items/jewel_topaz_g3.svg": "Tw0LtMKy",
  "icons/items/jewel_topaz_g3_cut.svg": "pWdcBjwG",
  "icons/items/jewel_topaz_g4.svg": "WIS3nv0L",
  "icons/items/jewel_topaz_g4_cut.svg": "SO9mW9TR",
  "icons/items/jewel_topaz_g5.svg": "TVB9ae66",
  "icons/items/jewel_topaz_g5_cut.svg": "X0YyoGBS",
  "icons/items/jewel_topaz_x.svg": "JDxtZs4e",
  "icons/items/jewel_topaz_x_cut.svg": "DOBO_VFX",
  "icons/items/kit_craftsman_starter.svg": "P29OmBJe",
  "icons/items/machine_elec_l.svg": "XPytgVcd",
  "icons/items/machine_elec_m.svg": "Kv8WEuVl",
  "icons/items/machine_elec_s.svg": "w7Y3aZ1-",
  "icons/items/machine_metal_l.svg": "Yw85Gfwh",
  "icons/items/machine_metal_m.svg": "JUywW-82",
  "icons/items/machine_metal_s.svg": "m30rJ6Lg",
  "icons/items/machine_smelt_l.svg": "zXp7kAx7",
  "icons/items/machine_smelt_m.svg": "EC5fAhkG",
  "icons/items/machine_smelt_s.svg": "v0ggKSFj",
  "icons/items/machine_wood_l.svg": "s-x7NRXD",
  "icons/items/machine_wood_m.svg": "-Qw19mLY",
  "icons/items/machine_wood_s.svg": "RKT61QzF",
  "icons/items/magic_substrate.svg": "BCd6kuXb",
  "icons/items/mangekyo_1.png": "DcnGhhl3",
  "icons/items/mangekyo_1.svg": "AxxTYymj",
  "icons/items/mangekyo_2.png": "Op0rfPgl",
  "icons/items/mangekyo_2.svg": "mRwFWA4L",
  "icons/items/module_ai.svg": "fCp96xPw",
  "icons/items/module_cnc.svg": "hKxNEIFR",
  "icons/items/oblivion_stone.svg": "a-YIkaNq",
  "icons/items/ore_common.svg": "P2gZRvBk",
  "icons/items/ore_copper.svg": "sxA9ITqu",
  "icons/items/ore_fine.svg": "zyyQOmoc",
  "icons/items/ore_iron.svg": "qaooZF4O",
  "icons/items/ore_pristine.svg": "CsAkQLYn",
  "icons/items/pants_pious_a.svg": "vxQxrJDB",
  "icons/items/pants_pious_b.svg": "nZRsPm0U",
  "icons/items/pants_pious_c.svg": "Nqox-XUK",
  "icons/items/pants_pious_s.svg": "xpxfarRh",
  "icons/items/pants_t10.svg": "2ul5janR",
  "icons/items/pants_t2.svg": "lwuilzMi",
  "icons/items/pants_t3.svg": "bbKKTTRl",
  "icons/items/pants_t4.svg": "oOpgPedG",
  "icons/items/pants_t5.svg": "_-SU6g8n",
  "icons/items/pants_t6.svg": "4B3WOWZw",
  "icons/items/pants_t7.svg": "qulQ9lDr",
  "icons/items/pants_t8.svg": "u9m612F8",
  "icons/items/pants_t9.svg": "D1wdO12P",
  "icons/items/plate_copper.svg": "NyH3nfhi",
  "icons/items/plate_iron.svg": "93E0W8_j",
  "icons/items/potion_hp.svg": "ziO_OqL3",
  "icons/items/potion_hp_20.svg": "UvwicUYc",
  "icons/items/potion_hp_40.svg": "vtRTZE3H",
  "icons/items/potion_hp_60.svg": "Kz-H7Riv",
  "icons/items/potion_hp_80.svg": "pwlXdBD9",
  "icons/items/potion_insight.svg": "iU7HyZ57",
  "icons/items/potion_mp.svg": "Avb65gYH",
  "icons/items/potion_mp_20.svg": "XY-A_MDc",
  "icons/items/potion_mp_40.svg": "EaD6MhEg",
  "icons/items/potion_mp_60.svg": "bLP8d9qO",
  "icons/items/potion_mp_80.svg": "6cdWQy-B",
  "icons/items/premium_bundle_180.svg": "jaQJteNa",
  "icons/items/premium_bundle_30.svg": "I8QSJo7S",
  "icons/items/premium_bundle_90.svg": "ZcBNHyQi",
  "icons/items/premium_perk_coupon.svg": "7N_8sG_E",
  "icons/items/premium_perk_loot.svg": "q1R7cWiQ",
  "icons/items/premium_perk_xp.svg": "r7sWCkFB",
  "icons/items/premium_seal_1d.svg": "PP--CeRo",
  "icons/items/premium_seal_2d.svg": "w4-eP-6s",
  "icons/items/premium_seal_30d.svg": "r5nMWYT1",
  "icons/items/premium_seal_7d.svg": "0lM1wR5M",
  "icons/items/primordial_matter.svg": "WpLDV12D",
  "icons/items/quest_token.svg": "zrPrRW15",
  "icons/items/quiver_pious_a.svg": "KGc8IaW0",
  "icons/items/quiver_pious_b.svg": "ZrwXUGyt",
  "icons/items/quiver_pious_c.svg": "RiG0WKO3",
  "icons/items/quiver_pious_s.svg": "jNWNHRxx",
  "icons/items/quiver_t3.svg": "JbJGpuKj",
  "icons/items/quiver_t5.svg": "dM5hDkMS",
  "icons/items/quiver_t7.svg": "vNgJxKAF",
  "icons/items/quiver_t9.svg": "57egwuR5",
  "icons/items/raffle_look_180.svg": "B7u2hB74",
  "icons/items/raffle_look_90.svg": "BApZjGms",
  "icons/items/raffle_ticket.svg": "8iWB2jXS",
  "icons/items/referral_aura_1.svg": "UpYMdTHR",
  "icons/items/referral_aura_2.svg": "8eIR7Lh9",
  "icons/items/referral_aura_3.svg": "G2GHszoK",
  "icons/items/referral_chest_hunter.svg": "EDDARQx9",
  "icons/items/referral_chest_seeker.svg": "mMj47OeW",
  "icons/items/referral_cloak_25.svg": "W7iVbs-V",
  "icons/items/referral_cloak_250.svg": "4c8xOGQu",
  "icons/items/referral_cloak_friend.svg": "PIRK_oyr",
  "icons/items/referral_cloak_inviter.svg": "7xWONB-E",
  "icons/items/referral_mark_60.svg": "SDta4NsF",
  "icons/items/referral_potion_hp.svg": "ba-aRMl6",
  "icons/items/referral_potion_mp.svg": "MtbJ7VQq",
  "icons/items/scripture_pious_a.svg": "oxMwZraq",
  "icons/items/scripture_pious_b.svg": "r4HF92qX",
  "icons/items/scripture_pious_c.svg": "X30Pm7BH",
  "icons/items/scripture_pious_s.svg": "pSIHMMGa",
  "icons/items/scripture_t3.svg": "6hIlw6hU",
  "icons/items/scripture_t5.svg": "Epyah_v5",
  "icons/items/scripture_t7.svg": "h4FqEPCu",
  "icons/items/scripture_t9.svg": "FlqRjo89",
  "icons/items/scroll_blessed_enchant_armor_a.svg": "0pXTf-s1",
  "icons/items/scroll_blessed_enchant_armor_b.svg": "ggksl463",
  "icons/items/scroll_blessed_enchant_armor_c.svg": "TvXbxC9m",
  "icons/items/scroll_blessed_enchant_armor_d.svg": "fmOeqJP7",
  "icons/items/scroll_blessed_enchant_armor_s.svg": "QRT2IYOB",
  "icons/items/scroll_blessed_enchant_weapon_a.svg": "14fxAEjl",
  "icons/items/scroll_blessed_enchant_weapon_b.svg": "JwK11OVd",
  "icons/items/scroll_blessed_enchant_weapon_c.svg": "_aLykUTy",
  "icons/items/scroll_blessed_enchant_weapon_d.svg": "A_r-vxOm",
  "icons/items/scroll_blessed_enchant_weapon_s.svg": "FCHqCSot",
  "icons/items/scroll_enchant_armor_a.svg": "mNUAX7dO",
  "icons/items/scroll_enchant_armor_b.svg": "11ycycy1",
  "icons/items/scroll_enchant_armor_c.svg": "zl52ffgY",
  "icons/items/scroll_enchant_armor_d.svg": "dnIvq99q",
  "icons/items/scroll_enchant_armor_s.svg": "hXzvQGLC",
  "icons/items/scroll_enchant_weapon_a.svg": "MgBrhLUp",
  "icons/items/scroll_enchant_weapon_b.svg": "1ZZnPr4s",
  "icons/items/scroll_enchant_weapon_c.svg": "Iy7RQQ-M",
  "icons/items/scroll_enchant_weapon_d.svg": "q3pVXAIE",
  "icons/items/scroll_enchant_weapon_s.svg": "AHC9NbuS",
  "icons/items/scroll_resurrection.svg": "pA5qRJj7",
  "icons/items/scroll_resurrection_greater.svg": "qVwPJEys",
  "icons/items/scroll_resurrection_weak.svg": "AY4VUsj5",
  "icons/items/senjutsu_eye.png": "D8zZEAnF",
  "icons/items/senjutsu_eye.svg": "a-H-13_w",
  "icons/items/sharingan_1.png": "Mvuen-BZ",
  "icons/items/sharingan_1.svg": "247wDGPX",
  "icons/items/sharingan_2.png": "pNyBkVuV",
  "icons/items/sharingan_2.svg": "BDK2ArJA",
  "icons/items/sharingan_3.png": "8ZeFHQ17",
  "icons/items/sharingan_3.svg": "q8Pi4wTW",
  "icons/items/shield_pious_a.svg": "CgrX063d",
  "icons/items/shield_pious_b.svg": "sDvmYjUQ",
  "icons/items/shield_pious_c.svg": "YhQXBGnl",
  "icons/items/shield_pious_s.svg": "jjHxlgk9",
  "icons/items/shield_t3.svg": "ukTKh_fl",
  "icons/items/shield_t5.svg": "vsnU8nc1",
  "icons/items/shield_t7.svg": "fGgTL1cG",
  "icons/items/shield_t9.svg": "IFFQeZq6",
  "icons/items/sigil_pious_a.svg": "9sCUZOtI",
  "icons/items/sigil_pious_b.svg": "fgr2T9Xt",
  "icons/items/sigil_pious_c.svg": "W4EsPXEb",
  "icons/items/sigil_pious_s.svg": "8aMlcI2l",
  "icons/items/sigil_t3.svg": "Pie6Afu3",
  "icons/items/sigil_t5.svg": "KHsa6O1y",
  "icons/items/sigil_t7.svg": "Zd4-BWNO",
  "icons/items/sigil_t9.svg": "gLQGZfK7",
  "icons/items/soul_charge.svg": "bGWBjU1O",
  "icons/items/soul_charge_wonder.svg": "-GDb7Wmo",
  "icons/items/spirit_charge.svg": "A-JmhDHv",
  "icons/items/spirit_charge_wonder.svg": "BptTqN8P",
  "icons/items/staff_pious_a.svg": "EOyH5VVz",
  "icons/items/staff_pious_b.svg": "3HstL7_a",
  "icons/items/staff_pious_c.svg": "ocHKFM4Z",
  "icons/items/staff_pious_s.svg": "RrobjbJN",
  "icons/items/staff_t10.svg": "CE71KWdx",
  "icons/items/staff_t2.svg": "vcEcb3As",
  "icons/items/staff_t3.svg": "HJ16m92v",
  "icons/items/staff_t4.svg": "FcUhZ9To",
  "icons/items/staff_t5.svg": "NKNGTwO3",
  "icons/items/staff_t6.svg": "RN9Up71e",
  "icons/items/staff_t7.svg": "Pxb68r_u",
  "icons/items/staff_t8.svg": "rRhiEo-j",
  "icons/items/staff_t9.svg": "WWa6k3sz",
  "icons/items/starter_blades.svg": "jgB1kUX_",
  "icons/items/starter_boots.svg": "h3tAiV8Z",
  "icons/items/starter_bow.svg": "KTwlANDk",
  "icons/items/starter_chest.svg": "v-7gmFWX",
  "icons/items/starter_cloak.svg": "tU0R9AbT",
  "icons/items/starter_cross.svg": "y3o8gLO2",
  "icons/items/starter_gloves.svg": "zYDjVkqV",
  "icons/items/starter_hammer.svg": "P40jODH7",
  "icons/items/starter_helm.svg": "1mXrvJjk",
  "icons/items/starter_pants.svg": "nIZ51IrS",
  "icons/items/starter_quiver.svg": "Xw0dXMJN",
  "icons/items/starter_scripture.svg": "8DIkj68U",
  "icons/items/starter_shield.svg": "be_k9w1h",
  "icons/items/starter_sigil.svg": "ywlXv8hA",
  "icons/items/starter_staff.svg": "ttkoYE5f",
  "icons/items/starter_sword.svg": "7ubXM2Z5",
  "icons/items/starter_token.svg": "rYQgCvsT",
  "icons/items/starter_tome.svg": "KESM9FX0",
  "icons/items/susano_1.svg": "P6CLRayZ",
  "icons/items/susano_2.svg": "7kFb79a_",
  "icons/items/sword_pious_a.svg": "-CzkL4Rv",
  "icons/items/sword_pious_b.svg": "HQdG9X9K",
  "icons/items/sword_pious_c.svg": "WTSDpT98",
  "icons/items/sword_pious_s.svg": "-xLoHzaY",
  "icons/items/sword_t10.svg": "oNHFZpKI",
  "icons/items/sword_t2.svg": "LFWvdfBr",
  "icons/items/sword_t3.svg": "RUruFX7p",
  "icons/items/sword_t4.svg": "H6n735Na",
  "icons/items/sword_t5.svg": "VnhUkOso",
  "icons/items/sword_t6.svg": "CPKeK0-g",
  "icons/items/sword_t7.svg": "90WEKqm-",
  "icons/items/sword_t8.svg": "tRkcn3VL",
  "icons/items/sword_t9.svg": "zT8rCAB7",
  "icons/items/token_pious_a.svg": "wng8jLP9",
  "icons/items/token_pious_b.svg": "kJknpz87",
  "icons/items/token_pious_c.svg": "gXtMdwB-",
  "icons/items/token_pious_s.svg": "jUXjIeFX",
  "icons/items/token_t3.svg": "IMKL0FGr",
  "icons/items/token_t5.svg": "TkJv0Hzi",
  "icons/items/token_t7.svg": "pqFTa8Ht",
  "icons/items/token_t9.svg": "J9wNAlIC",
  "icons/items/tome_pious_a.svg": "_rAsYzj8",
  "icons/items/tome_pious_b.svg": "TUDb7gxG",
  "icons/items/tome_pious_c.svg": "Yw_EVGeq",
  "icons/items/tome_pious_s.svg": "Rs0W9nIj",
  "icons/items/tome_t3.svg": "Y3iAJ6tQ",
  "icons/items/tome_t5.svg": "XSczZYh3",
  "icons/items/tome_t7.svg": "Ij88ty0B",
  "icons/items/tome_t9.svg": "BxGiBvj7",
  "icons/items/tool_axe.svg": "W0mSnxKh",
  "icons/items/tool_pickaxe.svg": "-tIWckKn",
  "icons/items/wolf_tag.svg": "hBczHXdY",
  "icons/items/wood_log.svg": "zEk8X-Fs",
  "icons/ui/dock-character.png": "20vh3_-B",
  "icons/ui/dock-character.svg": "8-wjs7Rs",
  "icons/ui/dock-clan.png": "eA8sU4cS",
  "icons/ui/dock-craft.png": "7nr3sWV9",
  "icons/ui/dock-craft.svg": "_0O6Pt71",
  "icons/ui/dock-debug.svg": "EmMl3CwT",
  "icons/ui/dock-inventory.png": "DjlYIfK5",
  "icons/ui/dock-inventory.svg": "xfl_0EGa",
  "icons/ui/dock-map.png": "Npw55FfA",
  "icons/ui/dock-map.svg": "s0e0mZSc",
  "icons/ui/dock-market.png": "Z-K9Ed7W",
  "icons/ui/dock-menu.png": "GKfS5oRW",
  "icons/ui/dock-menu.svg": "Phw7aXim",
  "icons/ui/dock-shop.svg": "q9SfEm0T",
  "icons/ui/dock-skills.png": "vIL9Dnpv",
  "icons/ui/dock-skills.svg": "1MVIQAsX",
  "icons/ui/equip-boots.svg": "KfhUZvHg",
  "icons/ui/equip-chest.svg": "lDfb8mZZ",
  "icons/ui/equip-cloak.svg": "smNcyo4y",
  "icons/ui/equip-eyes.svg": "5sdkexbA",
  "icons/ui/equip-gloves.svg": "Nynh33eQ",
  "icons/ui/equip-helmet.svg": "O_KqodDp",
  "icons/ui/equip-offhand.svg": "DuB_TCyM",
  "icons/ui/equip-pants.svg": "9VWhC6wd",
  "icons/ui/equip-weapon.svg": "xlDes0Fm",
  "icons/ui/lock.svg": "JvBWH4_H",
  "icons/ui/premium_banner.svg": "5IkiW0ZB",
  "icons/ui/premium_hero_seal.svg": "QhIUdrww",
  "sounds/abyss_cast.wav": "kx0C1ZMt",
  "sounds/abyss_curse.wav": "jseq7MOs",
  "sounds/abyss_drain.wav": "jnL5kVWA",
  "sounds/abyss_drain_cast.wav": "6Zt5oA1D",
  "sounds/abyss_harvest.wav": "qcGNzlJI",
  "sounds/abyss_hex.wav": "nb-rMXh0",
  "sounds/abyss_hush.wav": "-Rsq7neX",
  "sounds/abyss_orb.wav": "QJlLt1Sx",
  "sounds/abyss_orb_charge.wav": "JsEaBstT",
  "sounds/abyss_orb_hit.wav": "TJjkXVXe",
  "sounds/abyss_pact.wav": "9b_xXjxW",
  "sounds/ash_aggro.wav": "DcHrfn2y",
  "sounds/ash_hit.wav": "xtDCN5uo",
  "sounds/ash_swing.wav": "RemVfUTl",
  "sounds/bear_hit.wav": "eq_Zeopx",
  "sounds/bear_rage.wav": "30PVkXgG",
  "sounds/bear_roar.wav": "wr6sHFU8",
  "sounds/bear_swing.wav": "YPOZB21j",
  "sounds/beast_hit.wav": "jyVvpsJ5",
  "sounds/beast_swing.wav": "ygka7veF",
  "sounds/berserk_arc.wav": "G59pacvL",
  "sounds/berserk_chop.wav": "uQA5mLD7",
  "sounds/berserk_hit.wav": "lKeXAB8T",
  "sounds/berserk_mist.wav": "LZuVftF3",
  "sounds/berserk_step.wav": "j8begEfc",
  "sounds/berserk_throat.wav": "xbbrfIxo",
  "sounds/bow.wav": "A9e8150n",
  "sounds/brute_hit.wav": "tBHm_b4S",
  "sounds/brute_swing.wav": "Uij2pvs7",
  "sounds/charge.wav": "msat-lEo",
  "sounds/crit_hit.wav": "bqbBIMPw",
  "sounds/dance_fan.wav": "VAgLfiNj",
  "sounds/dance_glide.wav": "umBHhGOe",
  "sounds/dark_blight.wav": "uvN2kmRS",
  "sounds/dark_blight_hit.wav": "VODNhcBs",
  "sounds/dark_dose.wav": "4DEFtU2d",
  "sounds/dark_dose_hit.wav": "tkIbiIYq",
  "sounds/dark_draw.wav": "B75eqUA5",
  "sounds/dark_drip.wav": "ZC8ORYMC",
  "sounds/dark_numb.wav": "axPTqfbv",
  "sounds/dark_numb_hit.wav": "oFYcwBLS",
  "sounds/dark_rot.wav": "bem2XLQ0",
  "sounds/dark_rot_hit.wav": "kDy6z4Bg",
  "sounds/dark_step.wav": "BZ2xivrV",
  "sounds/dark_venom.wav": "f53cxCk4",
  "sounds/dark_venom_hit.wav": "qZSb3hJ_",
  "sounds/dash.wav": "BBtavPf7",
  "sounds/death_execute.wav": "9D3fqrNZ",
  "sounds/duel_parry.wav": "VKYbDc6l",
  "sounds/dusk_fan.wav": "_0oVeY5V",
  "sounds/dusk_glide.wav": "isP26vJ-",
  "sounds/dusk_precise.wav": "fmXjkuaI",
  "sounds/earthquake.wav": "_dKiZOu-",
  "sounds/elf_barbs.wav": "1jhVIyKi",
  "sounds/elf_cover.wav": "xE1KefBV",
  "sounds/elf_draw.wav": "Flv_kBJa",
  "sounds/elf_echo.wav": "yrYHkqq7",
  "sounds/elf_hit.wav": "z_RxBoWc",
  "sounds/elf_hush.wav": "2hCbNeO3",
  "sounds/elf_hush_hit.wav": "tzc1us0j",
  "sounds/elf_leap.wav": "LzabQJEi",
  "sounds/elf_mark.wav": "Cua4SKvJ",
  "sounds/elf_mark_hit.wav": "DjawZrxW",
  "sounds/elf_tremor.wav": "HNKmmGIs",
  "sounds/fire_cloak.wav": "6-YgdMsC",
  "sounds/fire_storm.wav": "qC7Zd-tl",
  "sounds/fireball_cast.wav": "Oq4_pXAQ",
  "sounds/fireball_charge.wav": "NEHOfrMq",
  "sounds/fireball_hit.wav": "UchwHv-M",
  "sounds/flame_dash.wav": "-BcbotVD",
  "sounds/flame_fist_hit.wav": "wOtgSFGq",
  "sounds/flame_fist_swing.wav": "jJt8VRd_",
  "sounds/flame_pillar.wav": "vFOJHIAL",
  "sounds/flame_rage.wav": "pKCkyIep",
  "sounds/flame_series_hit.wav": "BLTB4-pA",
  "sounds/flame_strike_hit.wav": "12qeTGFN",
  "sounds/flame_swing.wav": "aavcn-GA",
  "sounds/forge_aggro.wav": "5Fz2WQwD",
  "sounds/forge_block.wav": "UwXffVxd",
  "sounds/forge_call.wav": "XjIvcht6",
  "sounds/forge_clang.wav": "c4Ah9q1S",
  "sounds/forge_death.wav": "Pc_Z6IIP",
  "sounds/forge_edge.wav": "Ld6_qaaj",
  "sounds/forge_flat.wav": "ex-rCSDC",
  "sounds/forge_hit.wav": "3YI1USFM",
  "sounds/forge_might.wav": "xNOweLCe",
  "sounds/forge_stance.wav": "OFeSPZZG",
  "sounds/forge_swing.wav": "f-jOc39_",
  "sounds/ghost_death.wav": "-ygs4H9m",
  "sounds/ghost_hit.wav": "79VH6zeh",
  "sounds/ghost_wail.wav": "sTfIedvd",
  "sounds/glad_brace.wav": "HJYEWR4W",
  "sounds/glad_cleave.wav": "6ZxcVOvJ",
  "sounds/glad_cut.wav": "_sFWkgKl",
  "sounds/glad_finish.wav": "ideSLEnP",
  "sounds/glad_finish_hit.wav": "GBI1zpm5",
  "sounds/glad_grit.wav": "QlXMjVDM",
  "sounds/glad_rush.wav": "3U0upP4r",
  "sounds/glad_rush_hit.wav": "cfMjDYGp",
  "sounds/glad_strike.wav": "5nImjGSj",
  "sounds/grove_bloom.wav": "9995FMJM",
  "sounds/grove_heartwood.wav": "L2x1WMhx",
  "sounds/grove_heartwood_hit.wav": "F9UvkuUU",
  "sounds/grove_pollen.wav": "Cfx7mQ-W",
  "sounds/grove_pollen_hit.wav": "TodiCvDY",
  "sounds/grove_ray_cast.wav": "oCXePcdD",
  "sounds/grove_ray_hit.wav": "uTGcOkVf",
  "sounds/grove_rescue.wav": "3JVC9vl9",
  "sounds/grove_sap.wav": "gk2pbJ7o",
  "sounds/grove_sap_hit.wav": "X927xiN0",
  "sounds/grove_seed_cast.wav": "PXBcYeVF",
  "sounds/grove_seed_hit.wav": "xza8LgJi",
  "sounds/grove_spring.wav": "6l0mponn",
  "sounds/grove_spring_hit.wav": "eBqepEzw",
  "sounds/hammer_aa.wav": "AvnETvWi",
  "sounds/hammer_arc.wav": "EeaCNinO",
  "sounds/hammer_fell.wav": "nD6T6Y0b",
  "sounds/hammer_helm.wav": "ByjBMSPc",
  "sounds/hammer_hit.wav": "Hv20Z82n",
  "sounds/hammer_peak.wav": "gniBSTx-",
  "sounds/hammer_pin.wav": "nHMyVPFO",
  "sounds/hammer_wind.wav": "krGBCNre",
  "sounds/hearth_edge_cast.wav": "i6upnWe8",
  "sounds/hearth_edge_hit.wav": "oqpSXCvt",
  "sounds/hearth_keen_cast.wav": "aIaSoSFP",
  "sounds/hearth_keen_hit.wav": "RE-WIeK_",
  "sounds/hearth_mail_cast.wav": "tmTJK8r5",
  "sounds/hearth_mail_hit.wav": "6J_zJ0PP",
  "sounds/hearth_quench_cast.wav": "ZzKHDtNf",
  "sounds/hearth_quench_hit.wav": "rJGeKXpI",
  "sounds/hearth_spark_cast.wav": "Vw-Svouq",
  "sounds/hearth_spark_hit.wav": "pLMEKcI_",
  "sounds/hearth_vow_cast.wav": "bcWUHo2y",
  "sounds/hearth_vow_hit.wav": "mPn9xVxR",
  "sounds/hind_call.wav": "HqBPpk-5",
  "sounds/hind_hit.wav": "RJ6jS7iC",
  "sounds/hind_horn.wav": "Jwy0cPte",
  "sounds/hit.wav": "Dw3pAwBd",
  "sounds/holy_bless.wav": "WEc8-CTR",
  "sounds/holy_bless_hit.wav": "jzqtcqQY",
  "sounds/holy_cast.wav": "hl2Dc4B5",
  "sounds/holy_charge.wav": "rrryO2Jg",
  "sounds/holy_cleanse.wav": "2RCW3SlO",
  "sounds/holy_cleanse_hit.wav": "jvjyMprB",
  "sounds/holy_dome.wav": "OMukIIPy",
  "sounds/holy_hand_cast.wav": "y-CPq9M0",
  "sounds/holy_hand_hit.wav": "dcYaWYMK",
  "sounds/holy_heal_cast.wav": "EIZKqNtj",
  "sounds/holy_heal_hit.wav": "3hwfCH5k",
  "sounds/holy_hit.wav": "OVk-wNz8",
  "sounds/holy_mantle.wav": "26d6qage",
  "sounds/holy_mantle_hit.wav": "Pk1iUrxy",
  "sounds/holy_might.wav": "NwaVJbru",
  "sounds/holy_might_hit.wav": "i_6LMow-",
  "sounds/holy_nova.wav": "IQFuuXmX",
  "sounds/holy_nova_cast.wav": "0li9EPze",
  "sounds/holy_pace.wav": "9itSDJ78",
  "sounds/holy_pace_hit.wav": "HNrc93Fu",
  "sounds/holy_pulse_cast.wav": "W2CJ576b",
  "sounds/holy_pulse_hit.wav": "WJB7pG04",
  "sounds/holy_smite_cast.wav": "qzM3tCsV",
  "sounds/holy_smite_hit.wav": "JmSHNyEB",
  "sounds/holy_ward.wav": "PhoYye8B",
  "sounds/hunter_chase.wav": "YOwCPNsJ",
  "sounds/hunter_draw.wav": "9yX7hiif",
  "sounds/hunter_hamstring.wav": "-ZO4xPre",
  "sounds/hunter_hamstring_hit.wav": "5sXUjikO",
  "sounds/hunter_heavy.wav": "vl8SsTS5",
  "sounds/hunter_heavy_hit.wav": "mfCghuvO",
  "sounds/hunter_leap.wav": "Bh4Bmw1G",
  "sounds/hunter_prey.wav": "mFifYw6C",
  "sounds/hunter_prey_hit.wav": "bZRO1R8c",
  "sounds/ice_spikes.wav": "6GvQSqp4",
  "sounds/keeper_bark_cast.wav": "6BZkefmj",
  "sounds/keeper_bark_hit.wav": "hOBMAvb4",
  "sounds/keeper_breath_cast.wav": "GT6jP9N6",
  "sounds/keeper_breath_hit.wav": "RX9cKkUt",
  "sounds/keeper_dew_cast.wav": "gRMeVkzS",
  "sounds/keeper_dew_hit.wav": "kK7C60ks",
  "sounds/keeper_root_cast.wav": "jZf8N4_T",
  "sounds/keeper_root_hit.wav": "S3cYgbxR",
  "sounds/keeper_thicket_cast.wav": "JW6B5KgZ",
  "sounds/keeper_thicket_hit.wav": "9uIsfhpV",
  "sounds/keeper_vines_cast.wav": "SBg8gu9L",
  "sounds/keeper_vines_hit.wav": "zEFrAoA2",
  "sounds/knight_bash.wav": "UJdmmU02",
  "sounds/knight_bash_hit.wav": "2J0RyxPO",
  "sounds/knight_bastion.wav": "RGOcAZ9n",
  "sounds/knight_guard.wav": "u3jYlZQo",
  "sounds/knight_smash.wav": "AWGBEA7B",
  "sounds/knight_smash_hit.wav": "eBroF1u9",
  "sounds/knight_taunt.wav": "mcmSDi17",
  "sounds/level_up.wav": "NERiYz6Y",
  "sounds/lever.wav": "Cne9DToW",
  "sounds/marble_chisel.wav": "7guscpF2",
  "sounds/marble_growl.wav": "eTgP-3vv",
  "sounds/marble_hit.wav": "KlsOZIoM",
  "sounds/marks_crack.wav": "Ms1t4hTz",
  "sounds/marks_draw.wav": "kT9BOwAF",
  "sounds/marks_knock.wav": "oNrtsu9m",
  "sounds/marks_knock_draw.wav": "VCatyv9x",
  "sounds/marks_knock_hit.wav": "uI81WR13",
  "sounds/marks_plate.wav": "ed2rIOnc",
  "sounds/marks_prep.wav": "FdkfoPqu",
  "sounds/marks_snipe.wav": "rlh-gVDG",
  "sounds/marks_stance.wav": "XHHvkkJo",
  "sounds/mob_death.wav": "W6ZG5ZFr",
  "sounds/music/city.wav": "UGQ68ofp",
  "sounds/music/combat.mp3": "hsyyDhgZ",
  "sounds/music/combat.wav": "tGCPwp7z",
  "sounds/music/danger.wav": "wvpLjhe2",
  "sounds/music/death.mp3": "IRr8hRr2",
  "sounds/music/mire.wav": "ZfwSC2zM",
  "sounds/music/select.mp3": "txmo4vqH",
  "sounds/music/select.wav": "GXc_3z_L",
  "sounds/music/village.wav": "ETv5PF0w",
  "sounds/music/wild.mp3": "spJgGeED",
  "sounds/music/wild.wav": "TgQg6-50",
  "sounds/music/грустная.mp3": "IRr8hRr2",
  "sounds/music/лесная боевая.mp3": "hsyyDhgZ",
  "sounds/music/лесная деревня.mp3": "spJgGeED",
  "sounds/music/лунные мечты.mp3": "txmo4vqH",
  "sounds/night_strike.wav": "XJRSKLnf",
  "sounds/ord_brace.wav": "1SSHFH19",
  "sounds/ord_breach.wav": "FKcbeT5Q",
  "sounds/ord_breach_heavy.wav": "YCyWTNy3",
  "sounds/ord_shatter.wav": "w6fSdUJI",
  "sounds/pun_kill.wav": "Ykg-FyRK",
  "sounds/pun_mark.wav": "_uFvPJ3y",
  "sounds/pun_verdict.wav": "bbrv7WWm",
  "sounds/pun_verdict_heavy.wav": "grCwmewn",
  "sounds/pyro_cast.wav": "8oMvWdmH",
  "sounds/pyro_heart.wav": "NJkQWPgL",
  "sounds/pyro_pillar.wav": "S8wJLqMg",
  "sounds/pyro_pulse.wav": "YaALID7C",
  "sounds/pyro_ring.wav": "dhnzrccS",
  "sounds/pyro_sparks.wav": "l3XpcC5o",
  "sounds/pyro_storm.wav": "zwOOTc6Z",
  "sounds/rattler_hiss.wav": "QfHC8co3",
  "sounds/rattler_hit.wav": "39ypWCk_",
  "sounds/rattler_strike.wav": "6naui4Mq",
  "sounds/revive.wav": "mFC8MRQE",
  "sounds/rune_aegis_cast.wav": "pPsE6-CD",
  "sounds/rune_aegis_hit.wav": "0Goc-08S",
  "sounds/rune_bind_cast.wav": "imkpmspk",
  "sounds/rune_bind_hit.wav": "Fqa3PVH1",
  "sounds/rune_bless.wav": "pUx0WeNm",
  "sounds/rune_bless_hit.wav": "LPeURS-m",
  "sounds/rune_brand_hit.wav": "W2zfwHLS",
  "sounds/rune_break.wav": "EpTndx6v",
  "sounds/rune_burst_cast.wav": "JeZVLSXa",
  "sounds/rune_burst_hit.wav": "vEeK9LYY",
  "sounds/rune_cast.wav": "7O4DgiMV",
  "sounds/rune_charge.wav": "7kiN_kBw",
  "sounds/rune_cleanse.wav": "7LZpJeDS",
  "sounds/rune_cleanse_hit.wav": "0dtRFUD-",
  "sounds/rune_crack_cast.wav": "UVBViYRt",
  "sounds/rune_crack_hit.wav": "-4Fw-aQw",
  "sounds/rune_dome.wav": "5DyFaHAe",
  "sounds/rune_hand_cast.wav": "Zddl4nCM",
  "sounds/rune_hand_hit.wav": "9SuCbDfL",
  "sounds/rune_heal_cast.wav": "qMXWshh6",
  "sounds/rune_heal_hit.wav": "I6VZv8Rc",
  "sounds/rune_hit.wav": "BbbeRTBt",
  "sounds/rune_nova.wav": "CT7FfOEg",
  "sounds/rune_oath_cast.wav": "wFtAloGq",
  "sounds/rune_oath_hit.wav": "zC3_J2cB",
  "sounds/rune_pulse_cast.wav": "y7HfeV2C",
  "sounds/rune_pulse_hit.wav": "J6SQ5Cp9",
  "sounds/rune_smite_cast.wav": "J3Cym75I",
  "sounds/rune_smite_hit.wav": "jxG8LOES",
  "sounds/rune_ward.wav": "J3o7st7_",
  "sounds/rune_ward_cast.wav": "8DmBaX2w",
  "sounds/rune_ward_hit.wav": "Lmz0pu6Y",
  "sounds/slag_hit.wav": "l81NlSTF",
  "sounds/slag_swing.wav": "HpgNPjYE",
  "sounds/soul_cast.wav": "ikp0e3Sx",
  "sounds/soul_death.wav": "1-TW_v6l",
  "sounds/soul_hit.wav": "Fgo9n_-X",
  "sounds/spark_aggro.wav": "QGMiDno3",
  "sounds/spark_death.wav": "nwYLfK24",
  "sounds/spark_hit.wav": "6y72Mvzy",
  "sounds/spark_swing.wav": "gjP3NXdy",
  "sounds/stone_avalanche.wav": "cGiG5Urr",
  "sounds/stone_avalanche_cast.wav": "Wdwrx0r9",
  "sounds/stone_boulder.wav": "DI44N0mc",
  "sounds/stone_boulder_charge.wav": "3p2ss7ZX",
  "sounds/stone_boulder_hit.wav": "0e9gBq_K",
  "sounds/stone_boulder_shot.wav": "n-_TSCtq",
  "sounds/stone_cast.wav": "EsgM0KK-",
  "sounds/stone_hit.wav": "i1gQOfNi",
  "sounds/stone_petrify.wav": "F7jBf-id",
  "sounds/stone_quake.wav": "jaI8PDvZ",
  "sounds/stone_shard.wav": "BYF3L2Mo",
  "sounds/stone_shard_charge.wav": "FJnfoipA",
  "sounds/stone_shard_hit.wav": "6P_UR1_9",
  "sounds/stone_skin.wav": "GByLLyfX",
  "sounds/storm_calm.wav": "bytOkT4P",
  "sounds/storm_cast.wav": "6os7ExIV",
  "sounds/storm_crit.wav": "P4vUqpvt",
  "sounds/storm_hit.wav": "0ULPGfnf",
  "sounds/storm_hurricane.wav": "sEWm5XWg",
  "sounds/storm_hurricane_cast.wav": "c3l1DpTg",
  "sounds/storm_orb.wav": "BOxwL7m4",
  "sounds/storm_orb_charge.wav": "RAkz1SyS",
  "sounds/storm_orb_hit.wav": "TCJr1Zee",
  "sounds/storm_squall.wav": "-b1U9X7-",
  "sounds/storm_veil.wav": "2n6luLrD",
  "sounds/sword_hit.wav": "uSjOkm6F",
  "sounds/sword_swing.wav": "PvGhvePM",
  "sounds/tide_fall.wav": "kDBFC523",
  "sounds/tide_fall_cast.wav": "d9lYPnbW",
  "sounds/tide_fall_hit.wav": "ECdbm7j4",
  "sounds/tide_glide.wav": "gduMAXBq",
  "sounds/tide_orb.wav": "p58tklcH",
  "sounds/tide_orb_charge.wav": "omO8-quj",
  "sounds/tide_orb_hit.wav": "RBUb8cWW",
  "sounds/tide_repel.wav": "eLT0sZwv",
  "sounds/tide_surf.wav": "XX1yToFF",
  "sounds/tide_surf_burst.wav": "kScfP6Lo",
  "sounds/tide_surf_hit.wav": "P1gTYdxr",
  "sounds/tide_vortex.wav": "BIWvIx5S",
  "sounds/tide_vortex_cast.wav": "DXQKwoHb",
  "sounds/tide_vortex_hit.wav": "FU7FGOwI",
  "sounds/tide_wave.wav": "mqKrtkS4",
  "sounds/tide_wave_hit.wav": "x4y2bHgL",
  "sounds/tide_wave_roll.wav": "me2ZksVl",
  "sounds/toad_croak.wav": "JtwRxdRg",
  "sounds/toad_gulp.wav": "nPpVpc2h",
  "sounds/toad_hit.wav": "nWC1bry7",
  "sounds/topiary_hit.wav": "KmDTZCIr",
  "sounds/topiary_rustle.wav": "HpTY7XXl",
  "sounds/topiary_shear.wav": "qqbiVRyD",
  "sounds/travel_in.wav": "3EHaVnB-",
  "sounds/travel_out.wav": "cPtxJZUP",
  "sounds/twin_hit.wav": "doqWzPjv",
  "sounds/twin_swing.wav": "pyeeH9Ef",
  "sounds/ui_enchant_success.wav": "SoZlRMvX",
  "sounds/ui_enter_world.wav": "i7MV-VGd",
  "sounds/ui_error.wav": "sCMJoI3U",
  "sounds/ui_jewel_cut.wav": "j4Ih-tR9",
  "sounds/ui_jewel_extract.wav": "cy9IBEWs",
  "sounds/ui_jewel_insert.wav": "gScWK5Va",
  "sounds/ui_jewel_replace.wav": "Nqno9hMo",
  "sounds/ui_login_success.wav": "tWOE6YN4",
  "sounds/voevoda_bash.wav": "N8tpkh2-",
  "sounds/voevoda_cut.wav": "tn_Qm-iX",
  "sounds/voevoda_hit.wav": "gTAs468N",
  "sounds/voevoda_press.wav": "wrGvr-_P",
  "sounds/voevoda_roar.wav": "x1i5yXxH",
  "sounds/water_glide.wav": "8vk4MouP",
  "sounds/water_hit.wav": "ekm16wPc",
  "sounds/wolf_hit.mp3": "QoDmaw0N",
  "sounds/wolf_swing.wav": "_hEFic7t",
  "sprites/ash_warden_attack.png": "bwRf5bOu",
  "sprites/ash_warden_death.png": "khicJgYy",
  "sprites/ash_warden_idle.png": "940gQQ4v",
  "sprites/ash_warden_run.png": "nW3lC_0y",
  "sprites/baron.png": "9T6cEmzu",
  "sprites/bear_attack.png": "dtH7pkZA",
  "sprites/bear_death.png": "OzvudwP0",
  "sprites/bear_idle.png": "tY_ooPAA",
  "sprites/bear_run.png": "EbPC2WwY",
  "sprites/bellows_brute_attack.png": "OnnqWHST",
  "sprites/bellows_brute_death.png": "o-o6JjKW",
  "sprites/bellows_brute_idle.png": "MAKmtgAV",
  "sprites/bellows_brute_run.png": "8m0HCBnY",
  "sprites/blacksmith.png": "COilaASQ",
  "sprites/blossom_great.png": "49dtxP1A",
  "sprites/blossom_tree.png": "nVXRj1mR",
  "sprites/boar_attack.png": "DcUjtSn7",
  "sprites/boar_death.png": "Roewh4xe",
  "sprites/boar_idle.png": "i79X_4Ps",
  "sprites/boar_run.png": "vEsRsR_w",
  "sprites/bog_log.png": "HyCH1MT8",
  "sprites/bush.png": "Lk3LEmIx",
  "sprites/bush_berry.png": "Uh2J9O6l",
  "sprites/bush_thorn.png": "FY9-5X0b",
  "sprites/characters/body_dark_elf_f_cloak.png": "2mbstfXx",
  "sprites/characters/body_dark_elf_f_head.png": "DIxbW_pw",
  "sprites/characters/body_dark_elf_f_torso.png": "7JGHKCSz",
  "sprites/characters/body_dark_elf_m_cloak.png": "2mbstfXx",
  "sprites/characters/body_dark_elf_m_head.png": "DIxbW_pw",
  "sprites/characters/body_dark_elf_m_torso.png": "7JGHKCSz",
  "sprites/characters/body_dwarf_f_cloak.png": "2mbstfXx",
  "sprites/characters/body_dwarf_f_head.png": "5U7LJ6Ml",
  "sprites/characters/body_dwarf_f_torso.png": "HWYSh5Iw",
  "sprites/characters/body_dwarf_m_cloak.png": "2mbstfXx",
  "sprites/characters/body_dwarf_m_head.png": "5U7LJ6Ml",
  "sprites/characters/body_dwarf_m_torso.png": "HWYSh5Iw",
  "sprites/characters/body_human_f_cloak.png": "2mbstfXx",
  "sprites/characters/body_human_f_head.png": "Z8L-yKuS",
  "sprites/characters/body_human_f_torso.png": "xJucEvrS",
  "sprites/characters/body_human_m_cloak.png": "2mbstfXx",
  "sprites/characters/body_human_m_head.png": "Z8L-yKuS",
  "sprites/characters/body_human_m_torso.png": "xJucEvrS",
  "sprites/characters/body_light_elf_f_cloak.png": "2mbstfXx",
  "sprites/characters/body_light_elf_f_head.png": "Ws5_fa54",
  "sprites/characters/body_light_elf_f_torso.png": "3siOX4zK",
  "sprites/characters/body_light_elf_m_cloak.png": "2mbstfXx",
  "sprites/characters/body_light_elf_m_head.png": "Ws5_fa54",
  "sprites/characters/body_light_elf_m_torso.png": "3siOX4zK",
  "sprites/characters/body_orc_f_cloak.png": "2mbstfXx",
  "sprites/characters/body_orc_f_head.png": "naJV2gBl",
  "sprites/characters/body_orc_f_torso.png": "Jxos0jV-",
  "sprites/characters/body_orc_m_cloak.png": "2mbstfXx",
  "sprites/characters/body_orc_m_head.png": "naJV2gBl",
  "sprites/characters/body_orc_m_torso.png": "Jxos0jV-",
  "sprites/characters/boots_leather.png": "PZ5TPYmP",
  "sprites/characters/chest_leather.png": "uUh9WFm0",
  "sprites/characters/gloves_leather.png": "LVHyUWdo",
  "sprites/characters/helm_hood.png": "xcNR2O-g",
  "sprites/characters/pants_cloth.png": "1LYralZJ",
  "sprites/characters/weapon_bow.png": "nqAIxeQY",
  "sprites/chest.png": "vPtyGPWy",
  "sprites/elf_fence_sheet.png": "jxlItogU",
  "sprites/estate_door.png": "N2Y3-IAU",
  "sprites/estate_factory.png": "6qntX3Al",
  "sprites/estate_house_l.png": "csncRRZ8",
  "sprites/estate_house_m.png": "KXEwS4kp",
  "sprites/estate_house_s.png": "VUL3hUgO",
  "sprites/estate_lot_l.png": "wo_qaiZH",
  "sprites/estate_lot_m.png": "52G-sgJO",
  "sprites/estate_lot_s.png": "KgitPYDl",
  "sprites/estate_lumber.png": "pvpR5jvM",
  "sprites/estate_mine.png": "DlGyQlf9",
  "sprites/estate_office.png": "pQrYcLVS",
  "sprites/estate_sale_sign.png": "a8c8w2-x",
  "sprites/fence_spike.png": "v0iLIMja",
  "sprites/forge_warden_attack.png": "wfciYFOe",
  "sprites/forge_warden_death.png": "Lu5HjxMj",
  "sprites/forge_warden_idle.png": "AV-gctR3",
  "sprites/forge_warden_run.png": "xa7ZueMY",
  "sprites/furn_bed.png": "wMJYwQ2V",
  "sprites/furn_chair.png": "-3wR7m8f",
  "sprites/furn_garden.png": "H-ZuHcnn",
  "sprites/furn_plant.png": "-uBKJhhH",
  "sprites/furn_stove.png": "7vuLsi2z",
  "sprites/furn_table.png": "VHhbtGB_",
  "sprites/garden_lantern.png": "U4UzCnUU",
  "sprites/gate.png": "uuZRm1zK",
  "sprites/gate_ew.png": "M8WWcJg7",
  "sprites/gate_ew_open.png": "VgSMiUf-",
  "sprites/gate_open.png": "vP-k35Mq",
  "sprites/ghost_attack.png": "Bn46tVxy",
  "sprites/ghost_death.png": "mfGKwOmD",
  "sprites/ghost_idle.png": "k9GLaQv5",
  "sprites/ghost_run.png": "ZRMTB6LI",
  "sprites/grave_urn.png": "3CeH6c5l",
  "sprites/gravestone_cross.png": "E1KZh5xq",
  "sprites/gravestone_slab.png": "Vis-haV2",
  "sprites/hedge_sheet.png": "OEmTbU3w",
  "sprites/house_village_a.png": "GHTFzkib",
  "sprites/house_village_b.png": "pNE-vFOo",
  "sprites/human_m_ranger_attack.png": "HHrXnGJl",
  "sprites/human_m_ranger_death.png": "S6hzCsGT",
  "sprites/human_m_ranger_idle.png": "coqvzcNu",
  "sprites/human_m_ranger_run.png": "MlENPs8f",
  "sprites/instructor.png": "LkXs33iH",
  "sprites/iron_fence_sheet.png": "W2XHGCbJ",
  "sprites/lever.png": "HmeToNsu",
  "sprites/lever_on.png": "Hk5HAoea",
  "sprites/lily.png": "-uk7CiEO",
  "sprites/log_warehouse.png": "CdUoFhil",
  "sprites/lumber_stump.png": "J2AVozB9",
  "sprites/lumber_tree.png": "64GcfX2K",
  "sprites/lumber_tree_busy.png": "CREZOkL2",
  "sprites/lynx_attack.png": "8KN6jLbK",
  "sprites/lynx_death.png": "IYAbVm2l",
  "sprites/lynx_idle.png": "6QYwqIQm",
  "sprites/lynx_run.png": "T-GjMrkD",
  "sprites/machine_elec_l.png": "XBHgdvFq",
  "sprites/machine_elec_m.png": "BiLdzxR-",
  "sprites/machine_elec_s.png": "6gvtWV-X",
  "sprites/machine_metal_l.png": "9VrCL2yX",
  "sprites/machine_metal_m.png": "HTr9CdqM",
  "sprites/machine_metal_s.png": "FJSODWCs",
  "sprites/machine_smelt_l.png": "G8fU9NTb",
  "sprites/machine_smelt_m.png": "Ca1qknfU",
  "sprites/machine_smelt_s.png": "AiWLzPWW",
  "sprites/machine_wood_l.png": "pka9DQgF",
  "sprites/machine_wood_m.png": "hqlQ2jqH",
  "sprites/machine_wood_s.png": "oFcDoIm7",
  "sprites/marble_basin.png": "A1rdFUZN",
  "sprites/marble_hound_attack.png": "PQt8BP1A",
  "sprites/marble_hound_death.png": "wznnFHwW",
  "sprites/marble_hound_idle.png": "bPQeYME-",
  "sprites/marble_hound_run.png": "GOf_oUG0",
  "sprites/marble_urn.png": "001jPsQ9",
  "sprites/marsh_wisp.png": "9MVLeoX1",
  "sprites/merchant.png": "YJV3QqBu",
  "sprites/mire_toad_attack.png": "3CuhWhzX",
  "sprites/mire_toad_death.png": "JxMBEJSj",
  "sprites/mire_toad_idle.png": "d0vX61LD",
  "sprites/mire_toad_run.png": "JHhD8MLd",
  "sprites/notice_board.png": "KsdfqRxD",
  "sprites/ore_warehouse.png": "stG9xDls",
  "sprites/palisade_gate.png": "gbN0ByeP",
  "sprites/palisade_gate_ew.png": "AAIG96MH",
  "sprites/palisade_gate_ew_open.png": "LCiUnR4R",
  "sprites/palisade_gate_open.png": "kvIa02CL",
  "sprites/palisade_sheet.png": "gaacmlow",
  "sprites/portal_keeper.png": "aRl5CyXc",
  "sprites/rattler_attack.png": "9e_w_Qdh",
  "sprites/rattler_death.png": "2GOWi-n4",
  "sprites/rattler_idle.png": "KOEGWRQx",
  "sprites/rattler_run.png": "rja17rFU",
  "sprites/raven_fly.png": "vhUCl4GP",
  "sprites/raven_idle.png": "ZbMsBVZf",
  "sprites/reed.png": "EwOzP-mO",
  "sprites/rock.png": "TSj8Vm0t",
  "sprites/rose_arch.png": "IK4g-enW",
  "sprites/rose_bush.png": "A7Qdp1qf",
  "sprites/rose_queen_attack.png": "EpfiqBii",
  "sprites/rose_queen_death.png": "9gU_Ga6_",
  "sprites/rose_queen_idle.png": "nzDxvJrd",
  "sprites/rose_queen_run.png": "Uvm-qOxT",
  "sprites/shade_wolf_attack.png": "pRibYz1d",
  "sprites/shade_wolf_death.png": "wUlNNuVo",
  "sprites/shade_wolf_idle.png": "iuiTH8dd",
  "sprites/shade_wolf_run.png": "q0H-Xp9y",
  "sprites/silver_hind_attack.png": "78XlekF_",
  "sprites/silver_hind_death.png": "YR0uX9Gc",
  "sprites/silver_hind_idle.png": "8SA8RTO4",
  "sprites/silver_hind_run.png": "5pPqaE3d",
  "sprites/skeleton_mage_attack.png": "PTC9-hrn",
  "sprites/skeleton_mage_death.png": "5ZjRwp3L",
  "sprites/skeleton_mage_idle.png": "MmNjoLvF",
  "sprites/skeleton_mage_run.png": "ikgaXMGo",
  "sprites/slag_crawler_attack.png": "kDAiMyoo",
  "sprites/slag_crawler_death.png": "SfQb_UcJ",
  "sprites/slag_crawler_idle.png": "YKfAqcNr",
  "sprites/slag_crawler_run.png": "tpVV4_Uc",
  "sprites/soul_lantern.png": "Q4BUvhle",
  "sprites/spark_runner_attack.png": "e34dtlfJ",
  "sprites/spark_runner_death.png": "1_pkaA4k",
  "sprites/spark_runner_idle.png": "et-qFuze",
  "sprites/spark_runner_run.png": "gkB5WuX_",
  "sprites/stag_attack.png": "HOxYK05k",
  "sprites/stag_death.png": "qejo7NvC",
  "sprites/stag_idle.png": "o6Hjhi-B",
  "sprites/stag_run.png": "YwGFWLyT",
  "sprites/teleport_point.png": "XkrB-JV0",
  "sprites/topiary_lion_attack.png": "ydW__hri",
  "sprites/topiary_lion_death.png": "aG1b5_70",
  "sprites/topiary_lion_idle.png": "3Ez5UPhf",
  "sprites/topiary_lion_run.png": "OXNW22Un",
  "sprites/training_dummy_death.png": "Z0QxMfUZ",
  "sprites/training_dummy_idle.png": "saV__MaR",
  "sprites/tree.png": "uPp5k9tQ",
  "sprites/tree_cypress.png": "xGc9D67i",
  "sprites/tree_dead.png": "UKRNE28K",
  "sprites/tree_dead_snow.png": "NHPmQ-iI",
  "sprites/tree_pine.png": "jk7MVTsB",
  "sprites/tree_spruce_snow.png": "ZICjnyPb",
  "sprites/tree_willow.png": "RRhUqj2F",
  "sprites/tree_willow_great.png": "rGq3KLbF",
  "sprites/vein_copper.png": "2nqjq6ld",
  "sprites/vein_copper_spent.png": "mfNWA-kr",
  "sprites/vein_iron.png": "UBx4CFip",
  "sprites/vein_iron_spent.png": "jABWteKs",
  "sprites/wall_sheet.png": "DOoJc4cw",
  "sprites/wolf_attack.png": "Gpfkz4o_",
  "sprites/wolf_death.png": "In9SVsgE",
  "sprites/wolf_idle.png": "1KQJAg1-",
  "sprites/wolf_run.png": "KGRimrh7",
  "sprites/wolverine_attack.png": "acoRWZmH",
  "sprites/wolverine_death.png": "o9VnXsSe",
  "sprites/wolverine_idle.png": "fFWU5BXb",
  "sprites/wolverine_run.png": "jUDXaXAN",
  "tiles/ash.png": "AWMcYeic",
  "tiles/bank-face.png": "1JAlZ1wr",
  "tiles/blend-edge-0.png": "B2k4tmjF",
  "tiles/blend-edge-1.png": "hIgEpzn_",
  "tiles/blend-edge-2.png": "1Nmbu8ei",
  "tiles/blend-edge-3.png": "aDJKyLWC",
  "tiles/blend-edge.png": "B2k4tmjF",
  "tiles/cliff-face.png": "DnoZ7VP0",
  "tiles/cliff.png": "-PCOoHY3",
  "tiles/dirt.png": "5Y1Swrt_",
  "tiles/grass.png": "3UBuPiED",
  "tiles/ice.png": "-jgmD9MF",
  "tiles/mire.png": "ibPOEZ2F",
  "tiles/path.png": "TCEkJnzh",
  "tiles/sand.png": "wKVrBP82",
  "tiles/scorch.png": "P-zfFCRX",
  "tiles/sq/ash.png": "wdmJFKkq",
  "tiles/sq/bank-face.png": "1JAlZ1wr",
  "tiles/sq/cliff-face.png": "DnoZ7VP0",
  "tiles/sq/cliff.png": "-PCOoHY3",
  "tiles/sq/dirt.png": "5Y1Swrt_",
  "tiles/sq/grass.png": "3UBuPiED",
  "tiles/sq/ice.png": "-jgmD9MF",
  "tiles/sq/mire.png": "eIERuxF2",
  "tiles/sq/path.png": "TCEkJnzh",
  "tiles/sq/sand.png": "wKVrBP82",
  "tiles/sq/scorch.png": "P-zfFCRX",
  "tiles/sq/stone.png": "YV3UOFJs",
  "tiles/sq/water.png": "y_uYmcxa",
  "tiles/stone.png": "YV3UOFJs",
  "tiles/water.png": "y_uYmcxa",
  "tiles/wood.png": "e_UyyLW3",
};
